var map = {
	"./": [
		67672,
		9
	],
	"./@types/react-i18next/index.d": [
		61246,
		9,
		1246
	],
	"./@types/react-i18next/index.d.ts": [
		61246,
		9,
		1246
	],
	"./App.css": [
		93508,
		9,
		3508
	],
	"./assets/css/base.min.css": [
		31483,
		9,
		1483
	],
	"./assets/css/main.css": [
		88864,
		9
	],
	"./assets/icons/arrow-left-icon.svg": [
		81425,
		1,
		1425
	],
	"./assets/icons/close.svg": [
		50420,
		1,
		420
	],
	"./assets/icons/edit-icon.svg": [
		10438,
		1,
		438
	],
	"./assets/icons/entel-status/awaiting_delivery-icon.svg": [
		19508,
		1
	],
	"./assets/icons/entel-status/awaiting_store_confirmation-icon.svg": [
		27480,
		1
	],
	"./assets/icons/entel-status/canceled-icon.svg": [
		79016,
		1
	],
	"./assets/icons/entel-status/closed-icon.svg": [
		36223,
		1
	],
	"./assets/icons/entel-status/delivered-icon.svg": [
		71660,
		1
	],
	"./assets/icons/entel-status/in_return-icon.svg": [
		48602,
		1
	],
	"./assets/icons/entel-status/in_return_courier-icon.svg": [
		31951,
		1
	],
	"./assets/icons/entel-status/in_source_preparation-icon.svg": [
		57743,
		1
	],
	"./assets/icons/entel-status/in_transit-icon.svg": [
		24373,
		1
	],
	"./assets/icons/entel-status/pending_package-icon.svg": [
		3403,
		1
	],
	"./assets/icons/entel-status/pickup-icon.svg": [
		8677,
		1
	],
	"./assets/icons/entel-status/ready_for_pickup-icon.svg": [
		49590,
		1
	],
	"./assets/icons/entel-status/rescheduled-icon.svg": [
		69144,
		1
	],
	"./assets/icons/entel-status/return_in_review-icon.svg": [
		93141,
		1
	],
	"./assets/icons/entel-status/returned-icon.svg": [
		95444,
		1
	],
	"./assets/icons/entel/close.svg": [
		71231,
		1,
		1231
	],
	"./assets/icons/entel/edit-icon.svg": [
		19422,
		1,
		9422
	],
	"./assets/icons/entel/folder_upload_icon.svg": [
		73431,
		1,
		3431
	],
	"./assets/icons/entel/logout-icon.svg": [
		96330,
		1,
		6330
	],
	"./assets/icons/entel/menu/canceled-icon.svg": [
		44255,
		1,
		4255
	],
	"./assets/icons/entel/menu/closed-icon.svg": [
		29208,
		1,
		9208
	],
	"./assets/icons/entel/menu/confirm-icon.svg": [
		13589,
		1,
		3589
	],
	"./assets/icons/entel/menu/delivered-icon.svg": [
		79467,
		1,
		9467
	],
	"./assets/icons/entel/menu/delivery-icon.svg": [
		15659,
		1,
		5659
	],
	"./assets/icons/entel/menu/package-icon.svg": [
		40478,
		1,
		478
	],
	"./assets/icons/entel/menu/pickup-icon.svg": [
		57611,
		1,
		7611
	],
	"./assets/icons/entel/menu/shipped-icon.svg": [
		16509,
		1,
		6509
	],
	"./assets/icons/entel/trash-icon.svg": [
		44380,
		1,
		4380
	],
	"./assets/icons/entel/user_icon_alt.svg": [
		92433,
		1,
		2433
	],
	"./assets/icons/folder_upload_icon.svg": [
		40376,
		1,
		376
	],
	"./assets/icons/hamburger.svg": [
		40330,
		1,
		330
	],
	"./assets/icons/info_icon.svg": [
		29812,
		1,
		9812
	],
	"./assets/icons/logout-icon.svg": [
		6499,
		1,
		6499
	],
	"./assets/icons/loupe-icon.svg": [
		88095,
		1,
		8095
	],
	"./assets/icons/menu-admin-actions-icon.svg": [
		30983,
		1,
		983
	],
	"./assets/icons/menu-buy-icon.svg": [
		58243,
		1,
		8243
	],
	"./assets/icons/menu-calendar-icon.svg": [
		3464,
		1,
		3464
	],
	"./assets/icons/menu-home-icon.svg": [
		30259,
		1,
		259
	],
	"./assets/icons/menu-stats-icon.svg": [
		64790,
		1,
		4790
	],
	"./assets/icons/menu/canceled-icon.svg": [
		74404,
		1,
		4404
	],
	"./assets/icons/menu/closed-icon.svg": [
		66211,
		1,
		6211
	],
	"./assets/icons/menu/confirm-icon.svg": [
		23650,
		1,
		3650
	],
	"./assets/icons/menu/delivered-icon.svg": [
		43792,
		1,
		3792
	],
	"./assets/icons/menu/delivery-icon.svg": [
		91254,
		1,
		4879
	],
	"./assets/icons/menu/package-icon.svg": [
		65256,
		1,
		5256
	],
	"./assets/icons/menu/pickup-icon.svg": [
		95469,
		1,
		5469
	],
	"./assets/icons/menu/shipped-icon.svg": [
		76010,
		1,
		6010
	],
	"./assets/icons/password_icon.svg": [
		58235,
		1,
		8235
	],
	"./assets/icons/plus-icon.svg": [
		15176,
		1,
		5176
	],
	"./assets/icons/ship_ico.svg": [
		48292,
		1,
		8292
	],
	"./assets/icons/shiperto-status/awaiting_delivery-icon.svg": [
		6541,
		1
	],
	"./assets/icons/shiperto-status/awaiting_store_confirmation-icon.svg": [
		76876,
		1
	],
	"./assets/icons/shiperto-status/canceled-icon.svg": [
		75955,
		1
	],
	"./assets/icons/shiperto-status/closed-icon.svg": [
		67688,
		1
	],
	"./assets/icons/shiperto-status/delivered-icon.svg": [
		11792,
		1
	],
	"./assets/icons/shiperto-status/in_return-icon.svg": [
		67532,
		1
	],
	"./assets/icons/shiperto-status/in_return_courier-icon.svg": [
		49645,
		1
	],
	"./assets/icons/shiperto-status/in_source_preparation-icon.svg": [
		11229,
		1
	],
	"./assets/icons/shiperto-status/in_transit-icon.svg": [
		17601,
		1
	],
	"./assets/icons/shiperto-status/pending_package-icon.svg": [
		33211,
		1
	],
	"./assets/icons/shiperto-status/pickup-icon.svg": [
		1656,
		1
	],
	"./assets/icons/shiperto-status/ready_for_pickup-icon.svg": [
		55151,
		1
	],
	"./assets/icons/shiperto-status/rescheduled-icon.svg": [
		14761,
		1
	],
	"./assets/icons/shiperto-status/return_in_review-icon.svg": [
		95740,
		1
	],
	"./assets/icons/shiperto-status/returned-icon.svg": [
		37710,
		1
	],
	"./assets/icons/trash-icon.svg": [
		1967,
		1,
		1967
	],
	"./assets/icons/user_icon.svg": [
		26065,
		1,
		6065
	],
	"./assets/icons/user_icon_alt.svg": [
		64490,
		1,
		4490
	],
	"./assets/images/background-image-ship.svg": [
		38656,
		1,
		8656
	],
	"./assets/images/entel/product-image-default.svg": [
		33089,
		1,
		3089
	],
	"./assets/images/logo_entel.svg": [
		62571,
		1,
		2571
	],
	"./assets/images/logo_shiperto.svg": [
		10056,
		1,
		56
	],
	"./assets/images/shade-backg-ship.svg": [
		15912,
		1,
		5912
	],
	"./assets/images/shiperto/product-image-default.svg": [
		68650,
		1,
		8650
	],
	"./classes": [
		64829,
		9
	],
	"./classes/": [
		64829,
		9
	],
	"./classes/AxiosClient": [
		73710,
		9
	],
	"./classes/AxiosClient.ts": [
		73710,
		9
	],
	"./classes/Env": [
		52072,
		9
	],
	"./classes/Env.ts": [
		52072,
		9
	],
	"./classes/JsonEngine": [
		35000,
		9
	],
	"./classes/JsonEngine.ts": [
		35000,
		9
	],
	"./classes/Logger": [
		19320,
		9
	],
	"./classes/Logger.ts": [
		19320,
		9
	],
	"./classes/MultiClient": [
		84364,
		9
	],
	"./classes/MultiClient.ts": [
		84364,
		9
	],
	"./classes/index": [
		64829,
		9
	],
	"./classes/index.ts": [
		64829,
		9
	],
	"./components/AdvancedFileUpload/AdvancedFileUpload": [
		78402,
		9
	],
	"./components/AdvancedFileUpload/AdvancedFileUpload.styled": [
		76751,
		9
	],
	"./components/AdvancedFileUpload/AdvancedFileUpload.styled.ts": [
		76751,
		9
	],
	"./components/AdvancedFileUpload/AdvancedFileUpload.tsx": [
		78402,
		9
	],
	"./components/Commons/AutoComplete/InputAutoComplete": [
		5130,
		9,
		5130
	],
	"./components/Commons/AutoComplete/InputAutoComplete.sryled": [
		72436,
		9,
		2436
	],
	"./components/Commons/AutoComplete/InputAutoComplete.sryled.ts": [
		72436,
		9,
		2436
	],
	"./components/Commons/AutoComplete/InputAutoComplete.tsx": [
		5130,
		9,
		5130
	],
	"./components/Commons/BackBotton/BackBotton": [
		12940,
		9
	],
	"./components/Commons/BackBotton/BackBotton.styled": [
		58674,
		9
	],
	"./components/Commons/BackBotton/BackBotton.styled.ts": [
		58674,
		9
	],
	"./components/Commons/BackBotton/BackBotton.tsx": [
		12940,
		9
	],
	"./components/Commons/BackToDashboardButton/BackToDashboardButton": [
		30884,
		9
	],
	"./components/Commons/BackToDashboardButton/BackToDashboardButton.styled": [
		32321,
		9
	],
	"./components/Commons/BackToDashboardButton/BackToDashboardButton.styled.ts": [
		32321,
		9
	],
	"./components/Commons/BackToDashboardButton/BackToDashboardButton.tsx": [
		30884,
		9
	],
	"./components/Commons/BarCode": [
		2507,
		9
	],
	"./components/Commons/BarCode.tsx": [
		2507,
		9
	],
	"./components/Commons/BrandClient/LogoClient": [
		67350,
		9
	],
	"./components/Commons/BrandClient/LogoClient.tsx": [
		67350,
		9
	],
	"./components/Commons/Calendar/DateRangeCalendar": [
		81814,
		9
	],
	"./components/Commons/Calendar/DateRangeCalendar.styled": [
		1980,
		9
	],
	"./components/Commons/Calendar/DateRangeCalendar.styled.ts": [
		1980,
		9
	],
	"./components/Commons/Calendar/DateRangeCalendar.tsx": [
		81814,
		9
	],
	"./components/Commons/CheckBox": [
		65424,
		9
	],
	"./components/Commons/CheckBox.tsx": [
		65424,
		9
	],
	"./components/Commons/EmptyState/ContractorEmptyState": [
		31038,
		9
	],
	"./components/Commons/EmptyState/ContractorEmptyState.tsx": [
		31038,
		9
	],
	"./components/Commons/EmptyState/EmptyState": [
		86206,
		9
	],
	"./components/Commons/EmptyState/EmptyState.styled": [
		50806,
		9
	],
	"./components/Commons/EmptyState/EmptyState.styled.ts": [
		50806,
		9
	],
	"./components/Commons/EmptyState/EmptyState.tsx": [
		86206,
		9
	],
	"./components/Commons/Error/ErrorHandler": [
		76730,
		9
	],
	"./components/Commons/Error/ErrorHandler.styled": [
		22753,
		9
	],
	"./components/Commons/Error/ErrorHandler.styled.ts": [
		22753,
		9
	],
	"./components/Commons/Error/ErrorHandler.tsx": [
		76730,
		9
	],
	"./components/Commons/FileUpload/FileUpalder": [
		60804,
		9
	],
	"./components/Commons/FileUpload/FileUpalder.tsx": [
		60804,
		9
	],
	"./components/Commons/FileUpload/Uploader.styled": [
		27026,
		9
	],
	"./components/Commons/FileUpload/Uploader.styled.ts": [
		27026,
		9
	],
	"./components/Commons/Helmet/Helmet": [
		35380,
		9
	],
	"./components/Commons/Helmet/Helmet.tsx": [
		35380,
		9
	],
	"./components/Commons/HomeBotton/HomeBotton": [
		86327,
		9
	],
	"./components/Commons/HomeBotton/HomeBotton.tsx": [
		86327,
		9
	],
	"./components/Commons/HomeBotton/HomeButton.styled": [
		94057,
		9
	],
	"./components/Commons/HomeBotton/HomeButton.styled.ts": [
		94057,
		9
	],
	"./components/Commons/Image/Image": [
		43633,
		9
	],
	"./components/Commons/Image/Image.styled": [
		96284,
		9
	],
	"./components/Commons/Image/Image.styled.ts": [
		96284,
		9
	],
	"./components/Commons/Image/Image.tsx": [
		43633,
		9
	],
	"./components/Commons/Input": [
		95529,
		9
	],
	"./components/Commons/Input.tsx": [
		95529,
		9
	],
	"./components/Commons/Loading/Loading": [
		65564,
		9
	],
	"./components/Commons/Loading/Loading.tsx": [
		65564,
		9
	],
	"./components/Commons/Modal/Modal": [
		22509,
		9
	],
	"./components/Commons/Modal/Modal.styled": [
		25099,
		9
	],
	"./components/Commons/Modal/Modal.styled.ts": [
		25099,
		9
	],
	"./components/Commons/Modal/Modal.tsx": [
		22509,
		9
	],
	"./components/Commons/Notifications/Notification": [
		5135,
		9,
		5135
	],
	"./components/Commons/Notifications/Notification.tsx": [
		5135,
		9,
		5135
	],
	"./components/Commons/Notifications/NotificationList": [
		71206,
		9
	],
	"./components/Commons/Notifications/NotificationList.tsx": [
		71206,
		9
	],
	"./components/Commons/Pagination/Paginate": [
		44978,
		9
	],
	"./components/Commons/Pagination/Paginate.tsx": [
		44978,
		9
	],
	"./components/Commons/Pagination/Pagination.styled": [
		4397,
		9
	],
	"./components/Commons/Pagination/Pagination.styled.ts": [
		4397,
		9
	],
	"./components/Commons/PrivateRouteComponent": [
		96294,
		9
	],
	"./components/Commons/PrivateRouteComponent.tsx": [
		96294,
		9
	],
	"./components/Commons/PublicRouteComponent": [
		88650,
		9
	],
	"./components/Commons/PublicRouteComponent.tsx": [
		88650,
		9
	],
	"./components/Commons/RadioButton": [
		52767,
		9
	],
	"./components/Commons/RadioButton.tsx": [
		52767,
		9
	],
	"./components/Commons/RedirectWrapper": [
		30119,
		9
	],
	"./components/Commons/RedirectWrapper.tsx": [
		30119,
		9
	],
	"./components/Commons/RestrictedRouteWrapper": [
		67334,
		9
	],
	"./components/Commons/RestrictedRouteWrapper.tsx": [
		67334,
		9
	],
	"./components/Commons/SelectBox/SelectBox": [
		63981,
		9
	],
	"./components/Commons/SelectBox/SelectBox.styled": [
		83339,
		9
	],
	"./components/Commons/SelectBox/SelectBox.styled.ts": [
		83339,
		9
	],
	"./components/Commons/SelectBox/SelectBox.tsx": [
		63981,
		9
	],
	"./components/Commons/Skeleton/SkeletonGrid": [
		56401,
		9
	],
	"./components/Commons/Skeleton/SkeletonGrid.tsx": [
		56401,
		9
	],
	"./components/Commons/Skeleton/SkeletonGroupOrden": [
		58154,
		9
	],
	"./components/Commons/Skeleton/SkeletonGroupOrden.tsx": [
		58154,
		9
	],
	"./components/Commons/Skeleton/SkeletonShippinGroupDetail": [
		27868,
		9
	],
	"./components/Commons/Skeleton/SkeletonShippinGroupDetail.tsx": [
		27868,
		9
	],
	"./components/Commons/Skeleton/SkeletonThemeContainer": [
		56091,
		9
	],
	"./components/Commons/Skeleton/SkeletonThemeContainer.tsx": [
		56091,
		9
	],
	"./components/Commons/WindowModal/WindowModal": [
		50519,
		9
	],
	"./components/Commons/WindowModal/WindowModal.styled": [
		14419,
		9
	],
	"./components/Commons/WindowModal/WindowModal.styled.ts": [
		14419,
		9
	],
	"./components/Commons/WindowModal/WindowModal.tsx": [
		50519,
		9
	],
	"./components/Contractor/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard": [
		57728,
		9
	],
	"./components/Contractor/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard.styled": [
		16529,
		9
	],
	"./components/Contractor/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard.styled.ts": [
		16529,
		9
	],
	"./components/Contractor/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard.tsx": [
		57728,
		9
	],
	"./components/Contractor/OrderDetail/SummaryProducts/SummaryProductsList": [
		11748,
		9
	],
	"./components/Contractor/OrderDetail/SummaryProducts/SummaryProductsList.tsx": [
		11748,
		9
	],
	"./components/Contractor/ProductScanner/ScannerlItems": [
		93071,
		9,
		3071
	],
	"./components/Contractor/ProductScanner/ScannerlItems.styled": [
		68622,
		9,
		8622
	],
	"./components/Contractor/ProductScanner/ScannerlItems.styled.ts": [
		68622,
		9,
		8622
	],
	"./components/Contractor/ProductScanner/ScannerlItems.tsx": [
		93071,
		9,
		3071
	],
	"./components/ContractorAdvancedFileUpload/ContractorAdvancedFileUpload": [
		52515,
		9
	],
	"./components/ContractorAdvancedFileUpload/ContractorAdvancedFileUpload.tsx": [
		52515,
		9
	],
	"./components/ContractorAdvancedFileUpload/FileUpload.styled": [
		59392,
		9
	],
	"./components/ContractorAdvancedFileUpload/FileUpload.styled.ts": [
		59392,
		9
	],
	"./components/Core/DocumentsFiles/FileCard": [
		27448,
		9,
		7448
	],
	"./components/Core/DocumentsFiles/FileCard.styled": [
		9960,
		9,
		9960
	],
	"./components/Core/DocumentsFiles/FileCard.styled.ts": [
		9960,
		9,
		9960
	],
	"./components/Core/DocumentsFiles/FileCard.tsx": [
		27448,
		9,
		7448
	],
	"./components/Core/DocumentsFiles/FilesList": [
		90439,
		9,
		439
	],
	"./components/Core/DocumentsFiles/FilesList.tsx": [
		90439,
		9,
		439
	],
	"./components/Core/Multiclient": [
		53567,
		9
	],
	"./components/Core/Multiclient.tsx": [
		53567,
		9
	],
	"./components/Core/Order/CardOrder/CardOrdeItem": [
		75879,
		9
	],
	"./components/Core/Order/CardOrder/CardOrdeItem.tsx": [
		75879,
		9
	],
	"./components/Core/Order/CardOrder/CardOrderItem.styled": [
		54644,
		9
	],
	"./components/Core/Order/CardOrder/CardOrderItem.styled.ts": [
		54644,
		9
	],
	"./components/Core/Order/FilterDate/ContentCalendar/ButtonOptionCalendar": [
		71290,
		9
	],
	"./components/Core/Order/FilterDate/ContentCalendar/ButtonOptionCalendar.tsx": [
		71290,
		9
	],
	"./components/Core/Order/FilterDate/ContentCalendar/ContentCalendar": [
		81736,
		9
	],
	"./components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.styled": [
		77383,
		9
	],
	"./components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.styled.ts": [
		77383,
		9
	],
	"./components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.tsx": [
		81736,
		9
	],
	"./components/Core/Order/FilterDate/OrderFilterDate": [
		8237,
		9
	],
	"./components/Core/Order/FilterDate/OrderFilterDate.styled": [
		9025,
		9
	],
	"./components/Core/Order/FilterDate/OrderFilterDate.styled.ts": [
		9025,
		9
	],
	"./components/Core/Order/FilterDate/OrderFilterDate.tsx": [
		8237,
		9
	],
	"./components/Core/Order/OrderList": [
		65087,
		9
	],
	"./components/Core/Order/OrderList.styled": [
		43981,
		9
	],
	"./components/Core/Order/OrderList.styled.ts": [
		43981,
		9
	],
	"./components/Core/Order/OrderList.tsx": [
		65087,
		9
	],
	"./components/Core/Order/Sort/SortOrder": [
		95555,
		9
	],
	"./components/Core/Order/Sort/SortOrder.styled": [
		87334,
		9
	],
	"./components/Core/Order/Sort/SortOrder.styled.ts": [
		87334,
		9
	],
	"./components/Core/Order/Sort/SortOrder.tsx": [
		95555,
		9
	],
	"./components/Core/Order/hooks/UseChekedOrderList": [
		27261,
		9
	],
	"./components/Core/Order/hooks/UseChekedOrderList.ts": [
		27261,
		9
	],
	"./components/Core/Order/hooks/UseConditionalsGroupOrder": [
		48643,
		9
	],
	"./components/Core/Order/hooks/UseConditionalsGroupOrder.ts": [
		48643,
		9
	],
	"./components/Core/ProductBase/ProductDetail": [
		27301,
		9
	],
	"./components/Core/ProductBase/ProductDetail.tsx": [
		27301,
		9
	],
	"./components/Core/ProductTransition/ManualTransition": [
		83548,
		9,
		3548
	],
	"./components/Core/ProductTransition/ManualTransition.tsx": [
		83548,
		9,
		3548
	],
	"./components/Core/ProductTransition/ScannerlTransition": [
		66861,
		9,
		6861
	],
	"./components/Core/ProductTransition/ScannerlTransition.tsx": [
		66861,
		9,
		6861
	],
	"./components/Core/ScannerSimple/ScannerSimple": [
		55542,
		9,
		710,
		5542
	],
	"./components/Core/ScannerSimple/ScannerSimple.tsx": [
		55542,
		9,
		710,
		5542
	],
	"./components/Manifest/SearchInput": [
		45687,
		9
	],
	"./components/Manifest/SearchInput.module.css": [
		24585,
		9
	],
	"./components/Manifest/SearchInput.tsx": [
		45687,
		9
	],
	"./components/Manifest/UpLoadFile": [
		14244,
		9,
		4244
	],
	"./components/Manifest/UpLoadFile.tsx": [
		14244,
		9,
		4244
	],
	"./components/OrderDetail/DeliveryProductOrder/DeliveryAction": [
		45630,
		9
	],
	"./components/OrderDetail/DeliveryProductOrder/DeliveryAction.tsx": [
		45630,
		9
	],
	"./components/OrderDetail/ElockerQR/InfoElocker": [
		12345,
		9,
		2345
	],
	"./components/OrderDetail/ElockerQR/InfoElocker.styled": [
		29984,
		9,
		9984
	],
	"./components/OrderDetail/ElockerQR/InfoElocker.styled.ts": [
		29984,
		9,
		9984
	],
	"./components/OrderDetail/ElockerQR/InfoElocker.tsx": [
		12345,
		9,
		2345
	],
	"./components/OrderDetail/ElockerQR/QRCodeElocker": [
		34112,
		9,
		4112
	],
	"./components/OrderDetail/ElockerQR/QRCodeElocker.tsx": [
		34112,
		9,
		4112
	],
	"./components/OrderDetail/HeaderDetail/ContractorHeaderDetail": [
		33789,
		9
	],
	"./components/OrderDetail/HeaderDetail/ContractorHeaderDetail.tsx": [
		33789,
		9
	],
	"./components/OrderDetail/HeaderDetail/HeaderDetail": [
		79245,
		9
	],
	"./components/OrderDetail/HeaderDetail/HeaderDetail.styled": [
		31409,
		9
	],
	"./components/OrderDetail/HeaderDetail/HeaderDetail.styled.ts": [
		31409,
		9
	],
	"./components/OrderDetail/HeaderDetail/HeaderDetail.tsx": [
		79245,
		9
	],
	"./components/OrderDetail/HeaderDetail/SubHeaderDetail.styled": [
		61174,
		9
	],
	"./components/OrderDetail/HeaderDetail/SubHeaderDetail.styled.ts": [
		61174,
		9
	],
	"./components/OrderDetail/HistoryStatus/StatusShippingGroup": [
		92965,
		9,
		2965
	],
	"./components/OrderDetail/HistoryStatus/StatusShippingGroup.tsx": [
		92965,
		9,
		2965
	],
	"./components/OrderDetail/PackageProductOrder/PackageAction": [
		21182,
		9
	],
	"./components/OrderDetail/PackageProductOrder/PackageAction.tsx": [
		21182,
		9
	],
	"./components/OrderDetail/PickupProductOrder/PickupAction": [
		48932,
		9
	],
	"./components/OrderDetail/PickupProductOrder/PickupAction.tsx": [
		48932,
		9
	],
	"./components/OrderDetail/ProcessProducts/PickingAction": [
		7414,
		9
	],
	"./components/OrderDetail/ProcessProducts/PickingAction.tsx": [
		7414,
		9
	],
	"./components/OrderDetail/ProcessProducts/ProcessProductCard/ProcessProductCard": [
		62739,
		9
	],
	"./components/OrderDetail/ProcessProducts/ProcessProductCard/ProcessProductCard.styled": [
		9072,
		9
	],
	"./components/OrderDetail/ProcessProducts/ProcessProductCard/ProcessProductCard.styled.ts": [
		9072,
		9
	],
	"./components/OrderDetail/ProcessProducts/ProcessProductCard/ProcessProductCard.tsx": [
		62739,
		9
	],
	"./components/OrderDetail/ProcessProducts/ProcessProductsList": [
		830,
		9
	],
	"./components/OrderDetail/ProcessProducts/ProcessProductsList.tsx": [
		830,
		9
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductCount": [
		24904,
		9,
		4904
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductCount.tsx": [
		24904,
		9,
		4904
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductInformation": [
		83601,
		9,
		3601
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductInformation.tsx": [
		83601,
		9,
		3601
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductOderDetail": [
		89539,
		9
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductOderDetail.tsx": [
		89539,
		9
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductOrderDetail.styled": [
		92660,
		9
	],
	"./components/OrderDetail/ProductOrderConfirm/ProductOrderDetail.styled.ts": [
		92660,
		9
	],
	"./components/OrderDetail/ProductOrderConfirm/Sacanner/ScannerProducts": [
		71361,
		9,
		710,
		1361
	],
	"./components/OrderDetail/ProductOrderConfirm/Sacanner/ScannerProducts.styled": [
		35687,
		9,
		5687
	],
	"./components/OrderDetail/ProductOrderConfirm/Sacanner/ScannerProducts.styled.ts": [
		35687,
		9,
		5687
	],
	"./components/OrderDetail/ProductOrderConfirm/Sacanner/ScannerProducts.tsx": [
		71361,
		9,
		710,
		1361
	],
	"./components/OrderDetail/ProductOrderConfirm/ScannerInput/ScannerInput": [
		46202,
		9,
		6202
	],
	"./components/OrderDetail/ProductOrderConfirm/ScannerInput/ScannerInput.styled": [
		6951,
		9,
		6951
	],
	"./components/OrderDetail/ProductOrderConfirm/ScannerInput/ScannerInput.styled.ts": [
		6951,
		9,
		6951
	],
	"./components/OrderDetail/ProductOrderConfirm/ScannerInput/ScannerInput.tsx": [
		46202,
		9,
		6202
	],
	"./components/OrderDetail/SendCode/SendCode": [
		44814,
		9
	],
	"./components/OrderDetail/SendCode/SendCode.styled": [
		84101,
		9
	],
	"./components/OrderDetail/SendCode/SendCode.styled.ts": [
		84101,
		9
	],
	"./components/OrderDetail/SendCode/SendCode.tsx": [
		44814,
		9
	],
	"./components/OrderDetail/SendQR/SendQR": [
		31137,
		9
	],
	"./components/OrderDetail/SendQR/SendQR.styled": [
		90501,
		9
	],
	"./components/OrderDetail/SendQR/SendQR.styled.ts": [
		90501,
		9
	],
	"./components/OrderDetail/SendQR/SendQR.tsx": [
		31137,
		9
	],
	"./components/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard": [
		73040,
		9
	],
	"./components/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard.styled": [
		23786,
		9
	],
	"./components/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard.styled.ts": [
		23786,
		9
	],
	"./components/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard.tsx": [
		73040,
		9
	],
	"./components/OrderDetail/SummaryProducts/SummaryProductsList": [
		19945,
		9
	],
	"./components/OrderDetail/SummaryProducts/SummaryProductsList.tsx": [
		19945,
		9
	],
	"./components/OrderDetail/TagPrint/TagInfoCustomer": [
		13666,
		9
	],
	"./components/OrderDetail/TagPrint/TagInfoCustomer.tsx": [
		13666,
		9
	],
	"./components/OrderDetail/TagPrint/TagPrintContent": [
		65389,
		9
	],
	"./components/OrderDetail/TagPrint/TagPrintContent.styled": [
		96502,
		9
	],
	"./components/OrderDetail/TagPrint/TagPrintContent.styled.ts": [
		96502,
		9
	],
	"./components/OrderDetail/TagPrint/TagPrintContent.tsx": [
		65389,
		9
	],
	"./components/OrderDetail/TagPrint/render": [
		81459,
		9
	],
	"./components/OrderDetail/TagPrint/render/": [
		81459,
		9
	],
	"./components/OrderDetail/TagPrint/render/Field": [
		46276,
		9
	],
	"./components/OrderDetail/TagPrint/render/Field.tsx": [
		46276,
		9
	],
	"./components/OrderDetail/TagPrint/render/Fields": [
		95040,
		9
	],
	"./components/OrderDetail/TagPrint/render/Fields.tsx": [
		95040,
		9
	],
	"./components/OrderDetail/TagPrint/render/dataFields": [
		58471,
		9
	],
	"./components/OrderDetail/TagPrint/render/dataFields.tsx": [
		58471,
		9
	],
	"./components/OrderDetail/TagPrint/render/index": [
		81459,
		9
	],
	"./components/OrderDetail/TagPrint/render/index.tsx": [
		81459,
		9
	],
	"./components/OrderDetail/TransitProductOrder/TransitAction": [
		10402,
		9
	],
	"./components/OrderDetail/TransitProductOrder/TransitAction.tsx": [
		10402,
		9
	],
	"./components/SearchForm/SearchForm": [
		42653,
		9
	],
	"./components/SearchForm/SearchForm.styled": [
		70801,
		9
	],
	"./components/SearchForm/SearchForm.styled.ts": [
		70801,
		9
	],
	"./components/SearchForm/SearchForm.tsx": [
		42653,
		9
	],
	"./components/Summary/Summary.styled": [
		81883,
		9
	],
	"./components/Summary/Summary.styled.ts": [
		81883,
		9
	],
	"./components/Summary/SummaryOption/CardOption": [
		54813,
		9
	],
	"./components/Summary/SummaryOption/CardOption.styled": [
		61114,
		9
	],
	"./components/Summary/SummaryOption/CardOption.styled.ts": [
		61114,
		9
	],
	"./components/Summary/SummaryOption/CardOption.tsx": [
		54813,
		9
	],
	"./components/Summary/SummaryOptions": [
		63519,
		9
	],
	"./components/Summary/SummaryOptions.tsx": [
		63519,
		9
	],
	"./components/Theme/Header/Header": [
		51448,
		9
	],
	"./components/Theme/Header/Header.styled": [
		30678,
		9
	],
	"./components/Theme/Header/Header.styled.ts": [
		30678,
		9
	],
	"./components/Theme/Header/Header.tsx": [
		51448,
		9
	],
	"./components/Theme/Layout/Main/MainLayout": [
		57341,
		9
	],
	"./components/Theme/Layout/Main/MainLayout.styled": [
		81791,
		9
	],
	"./components/Theme/Layout/Main/MainLayout.styled.ts": [
		81791,
		9
	],
	"./components/Theme/Layout/Main/MainLayout.tsx": [
		57341,
		9
	],
	"./components/Theme/Sidebar/Navigation/NavigationMenu": [
		81507,
		9
	],
	"./components/Theme/Sidebar/Navigation/NavigationMenu.styled": [
		35771,
		9
	],
	"./components/Theme/Sidebar/Navigation/NavigationMenu.styled.ts": [
		35771,
		9
	],
	"./components/Theme/Sidebar/Navigation/NavigationMenu.tsx": [
		81507,
		9
	],
	"./components/Theme/Sidebar/SideBar": [
		4639,
		9
	],
	"./components/Theme/Sidebar/SideBar.styled": [
		84620,
		9
	],
	"./components/Theme/Sidebar/SideBar.styled.ts": [
		84620,
		9
	],
	"./components/Theme/Sidebar/SideBar.tsx": [
		4639,
		9
	],
	"./components/Theme/Sidebar/Support/SupportSection": [
		35664,
		9
	],
	"./components/Theme/Sidebar/Support/SupportSection.styled": [
		93358,
		9
	],
	"./components/Theme/Sidebar/Support/SupportSection.styled.ts": [
		93358,
		9
	],
	"./components/Theme/Sidebar/Support/SupportSection.tsx": [
		35664,
		9
	],
	"./components/Transfer/ModalMessage/ModalMessage": [
		78579,
		9
	],
	"./components/Transfer/ModalMessage/ModalMessage.styled": [
		6310,
		9
	],
	"./components/Transfer/ModalMessage/ModalMessage.styled.ts": [
		6310,
		9
	],
	"./components/Transfer/ModalMessage/ModalMessage.tsx": [
		78579,
		9
	],
	"./components/Transfer/ProcessProductCard/ProcessProductCard": [
		11068,
		9
	],
	"./components/Transfer/ProcessProductCard/ProcessProductCard.tsx": [
		11068,
		9
	],
	"./components/Transfer/ProcessProductsList": [
		99292,
		9
	],
	"./components/Transfer/ProcessProductsList.tsx": [
		99292,
		9
	],
	"./components/User/Login/LoginForm": [
		45276,
		9,
		5276
	],
	"./components/User/Login/LoginForm.styled": [
		52016,
		9,
		2016
	],
	"./components/User/Login/LoginForm.styled.ts": [
		52016,
		9,
		2016
	],
	"./components/User/Login/LoginForm.tsx": [
		45276,
		9,
		5276
	],
	"./components/User/Login/Logo": [
		21065,
		9,
		1065
	],
	"./components/User/Login/Logo.tsx": [
		21065,
		9,
		1065
	],
	"./components/User/NewPassword/NewPasswordForm": [
		66276,
		9,
		6276
	],
	"./components/User/NewPassword/NewPasswordForm.tsx": [
		66276,
		9,
		6276
	],
	"./components/User/Profile/UserInfo/UserInfoProfile": [
		20726,
		9
	],
	"./components/User/Profile/UserInfo/UserInfoProfile.styled": [
		18979,
		9
	],
	"./components/User/Profile/UserInfo/UserInfoProfile.styled.ts": [
		18979,
		9
	],
	"./components/User/Profile/UserInfo/UserInfoProfile.tsx": [
		20726,
		9
	],
	"./components/User/Profile/UserProfileForm": [
		69016,
		9
	],
	"./components/User/Profile/UserProfileForm.styled": [
		88880,
		9
	],
	"./components/User/Profile/UserProfileForm.styled.ts": [
		88880,
		9
	],
	"./components/User/Profile/UserProfileForm.tsx": [
		69016,
		9
	],
	"./components/User/Remember/RememberForm": [
		18831,
		9,
		8831
	],
	"./components/User/Remember/RememberForm.tsx": [
		18831,
		9,
		8831
	],
	"./config/ShemaForms": [
		21079,
		9
	],
	"./config/ShemaForms.ts": [
		21079,
		9
	],
	"./config/axiosClient": [
		41181,
		9
	],
	"./config/axiosClient.ts": [
		41181,
		9
	],
	"./config/config": [
		68438,
		9
	],
	"./config/config.ts": [
		68438,
		9
	],
	"./config/configEnv": [
		93970,
		9
	],
	"./config/configEnv.ts": [
		93970,
		9
	],
	"./containers/App/AppContainer": [
		37354,
		9
	],
	"./containers/App/AppContainer.tsx": [
		37354,
		9
	],
	"./containers/DashBoard/DashboardContainer": [
		81371,
		9
	],
	"./containers/DashBoard/DashboardContainer.tsx": [
		81371,
		9
	],
	"./context/actionsTypes": [
		15480,
		9
	],
	"./context/actionsTypes/": [
		15480,
		9
	],
	"./context/actionsTypes/AuthTypes": [
		88915,
		9,
		8915
	],
	"./context/actionsTypes/AuthTypes.ts": [
		88915,
		9,
		8915
	],
	"./context/actionsTypes/NotificationActionsType": [
		1870,
		9,
		1870
	],
	"./context/actionsTypes/NotificationActionsType.ts": [
		1870,
		9,
		1870
	],
	"./context/actionsTypes/OrderTypes": [
		38343,
		9
	],
	"./context/actionsTypes/OrderTypes.ts": [
		38343,
		9
	],
	"./context/actionsTypes/index": [
		15480,
		9
	],
	"./context/actionsTypes/index.ts": [
		15480,
		9
	],
	"./context/context": [
		5720,
		9
	],
	"./context/context/": [
		5720,
		9
	],
	"./context/context/AuthContext": [
		33253,
		9
	],
	"./context/context/AuthContext.tsx": [
		33253,
		9
	],
	"./context/context/GlobalContext": [
		28789,
		9
	],
	"./context/context/GlobalContext.tsx": [
		28789,
		9
	],
	"./context/context/OrderContext": [
		80081,
		9
	],
	"./context/context/OrderContext.tsx": [
		80081,
		9
	],
	"./context/context/index": [
		5720,
		9
	],
	"./context/context/index.ts": [
		5720,
		9
	],
	"./context/inits": [
		48581,
		9,
		8581
	],
	"./context/inits/": [
		48581,
		9,
		8581
	],
	"./context/inits/AuthReducerInit": [
		72152,
		9
	],
	"./context/inits/AuthReducerInit.ts": [
		72152,
		9
	],
	"./context/inits/OrderReducerInit": [
		36138,
		9
	],
	"./context/inits/OrderReducerInit.ts": [
		36138,
		9
	],
	"./context/inits/index": [
		48581,
		9,
		8581
	],
	"./context/inits/index.ts": [
		48581,
		9,
		8581
	],
	"./context/providers": [
		6002,
		9
	],
	"./context/providers/": [
		6002,
		9
	],
	"./context/providers/AuthProvider": [
		5061,
		9
	],
	"./context/providers/AuthProvider.tsx": [
		5061,
		9
	],
	"./context/providers/GlobalProvider": [
		81411,
		9
	],
	"./context/providers/GlobalProvider.tsx": [
		81411,
		9
	],
	"./context/providers/OrderProvider": [
		71597,
		9
	],
	"./context/providers/OrderProvider.tsx": [
		71597,
		9
	],
	"./context/providers/index": [
		6002,
		9
	],
	"./context/providers/index.ts": [
		6002,
		9
	],
	"./context/reducers": [
		41622,
		9
	],
	"./context/reducers/": [
		41622,
		9
	],
	"./context/reducers/AuthReducer": [
		9825,
		9
	],
	"./context/reducers/AuthReducer.ts": [
		9825,
		9
	],
	"./context/reducers/NotificationReducer": [
		41306,
		9
	],
	"./context/reducers/NotificationReducer.ts": [
		41306,
		9
	],
	"./context/reducers/OrderReducer": [
		75590,
		9
	],
	"./context/reducers/OrderReducer.ts": [
		75590,
		9
	],
	"./context/reducers/index": [
		41622,
		9
	],
	"./context/reducers/index.ts": [
		41622,
		9
	],
	"./context/types/GlobalStateTypes": [
		23712,
		9,
		3712
	],
	"./context/types/GlobalStateTypes.ts": [
		23712,
		9,
		3712
	],
	"./enums/CommonEnum": [
		20878,
		9
	],
	"./enums/CommonEnum.ts": [
		20878,
		9
	],
	"./enums/ContractorEnum": [
		10083,
		9
	],
	"./enums/ContractorEnum.ts": [
		10083,
		9
	],
	"./enums/FilterOptionsCalendarEnum": [
		88093,
		9
	],
	"./enums/FilterOptionsCalendarEnum.ts": [
		88093,
		9
	],
	"./enums/OptionsFilterEnum": [
		20622,
		9
	],
	"./enums/OptionsFilterEnum.tsx": [
		20622,
		9
	],
	"./enums/OptionsSendCodeEnum": [
		31866,
		9
	],
	"./enums/OptionsSendCodeEnum.ts": [
		31866,
		9
	],
	"./enums/OrderEnum": [
		51509,
		9
	],
	"./enums/OrderEnum.ts": [
		51509,
		9
	],
	"./enums/ResourcePermissionsEnum": [
		37381,
		9
	],
	"./enums/ResourcePermissionsEnum.ts": [
		37381,
		9
	],
	"./enums/ResourceRoleEnum": [
		26777,
		9
	],
	"./enums/ResourceRoleEnum.ts": [
		26777,
		9
	],
	"./enums/TransactionCodeEnum": [
		27608,
		9
	],
	"./enums/TransactionCodeEnum.ts": [
		27608,
		9
	],
	"./enums/shippinggroupEmun": [
		60370,
		9
	],
	"./enums/shippinggroupEmun.ts": [
		60370,
		9
	],
	"./helpers/FormatDateHelper": [
		79426,
		9
	],
	"./helpers/FormatDateHelper.ts": [
		79426,
		9
	],
	"./helpers/InitStateGeneral": [
		70045,
		9
	],
	"./helpers/InitStateGeneral.ts": [
		70045,
		9
	],
	"./helpers/UtilsHelper": [
		58288,
		9
	],
	"./helpers/UtilsHelper.ts": [
		58288,
		9
	],
	"./helpers/constHelper": [
		72852,
		9
	],
	"./helpers/constHelper.ts": [
		72852,
		9
	],
	"./helpers/passwordStrengthValidation": [
		45666,
		9
	],
	"./helpers/passwordStrengthValidation.ts": [
		45666,
		9
	],
	"./helpers/pdfGenerationHelper": [
		4758,
		9
	],
	"./helpers/pdfGenerationHelper.ts": [
		4758,
		9
	],
	"./helpers/validationRoutesHelper": [
		15226,
		9
	],
	"./helpers/validationRoutesHelper.ts": [
		15226,
		9
	],
	"./helpers/websiteHelper": [
		17375,
		9
	],
	"./helpers/websiteHelper.ts": [
		17375,
		9
	],
	"./hoc/OrderDetailHOC": [
		58653,
		9
	],
	"./hoc/OrderDetailHOC.tsx": [
		58653,
		9
	],
	"./hooks": [
		55405,
		9
	],
	"./hooks/": [
		55405,
		9
	],
	"./hooks/Contractor/useGetSgsByStatus": [
		74533,
		9
	],
	"./hooks/Contractor/useGetSgsByStatus.ts": [
		74533,
		9
	],
	"./hooks/Media/useFormConfig": [
		19491,
		9
	],
	"./hooks/Media/useFormConfig.tsx": [
		19491,
		9
	],
	"./hooks/UseCancelDecreaseOrder": [
		87779,
		9
	],
	"./hooks/UseCancelDecreaseOrder.ts": [
		87779,
		9
	],
	"./hooks/UseCancelOrder": [
		67540,
		9
	],
	"./hooks/UseCancelOrder.ts": [
		67540,
		9
	],
	"./hooks/UseCancelToken": [
		51915,
		9
	],
	"./hooks/UseCancelToken.ts": [
		51915,
		9
	],
	"./hooks/UseContractor": [
		60345,
		9
	],
	"./hooks/UseContractor.ts": [
		60345,
		9
	],
	"./hooks/UseContractorValidateSeries": [
		41645,
		9,
		1645
	],
	"./hooks/UseContractorValidateSeries.tsx": [
		41645,
		9,
		1645
	],
	"./hooks/UseCustomerRejectOrder": [
		98972,
		9
	],
	"./hooks/UseCustomerRejectOrder.ts": [
		98972,
		9
	],
	"./hooks/UseDeliveredRejectOrder": [
		4077,
		9
	],
	"./hooks/UseDeliveredRejectOrder.ts": [
		4077,
		9
	],
	"./hooks/UseDeliveredReturnOrder": [
		50369,
		9
	],
	"./hooks/UseDeliveredReturnOrder.ts": [
		50369,
		9
	],
	"./hooks/UseFilterShippingType": [
		76189,
		9
	],
	"./hooks/UseFilterShippingType.ts": [
		76189,
		9
	],
	"./hooks/UseGetMenuUser": [
		17946,
		9
	],
	"./hooks/UseGetMenuUser.ts": [
		17946,
		9
	],
	"./hooks/UseGetMultiClient": [
		55624,
		9
	],
	"./hooks/UseGetMultiClient.ts": [
		55624,
		9
	],
	"./hooks/UseGetOrderDetail": [
		16799,
		9
	],
	"./hooks/UseGetOrderDetail.ts": [
		16799,
		9
	],
	"./hooks/UseGetTicketOrder": [
		75905,
		9
	],
	"./hooks/UseGetTicketOrder.ts": [
		75905,
		9
	],
	"./hooks/UseGetUserById": [
		3456,
		9
	],
	"./hooks/UseGetUserById.ts": [
		3456,
		9
	],
	"./hooks/UseGroupedOrderByCount": [
		89104,
		9
	],
	"./hooks/UseGroupedOrderByCount.ts": [
		89104,
		9
	],
	"./hooks/UseHideActionButtons": [
		15136,
		9
	],
	"./hooks/UseHideActionButtons.ts": [
		15136,
		9
	],
	"./hooks/UseListRoles": [
		2188,
		9
	],
	"./hooks/UseListRoles.ts": [
		2188,
		9
	],
	"./hooks/UseListSourcesOSRM": [
		56444,
		9
	],
	"./hooks/UseListSourcesOSRM.ts": [
		56444,
		9
	],
	"./hooks/UseListUsers": [
		94369,
		9
	],
	"./hooks/UseListUsers.ts": [
		94369,
		9
	],
	"./hooks/UseLogin": [
		82396,
		9
	],
	"./hooks/UseLogin.ts": [
		82396,
		9
	],
	"./hooks/UseManifest": [
		70405,
		9
	],
	"./hooks/UseManifest.ts": [
		70405,
		9
	],
	"./hooks/UseParentContainer": [
		79262,
		9
	],
	"./hooks/UseParentContainer.ts": [
		79262,
		9
	],
	"./hooks/UsePassword": [
		67987,
		9,
		7987
	],
	"./hooks/UsePassword.ts": [
		67987,
		9,
		7987
	],
	"./hooks/UseScanner": [
		90639,
		9,
		710,
		639
	],
	"./hooks/UseScanner.ts": [
		90639,
		9,
		710,
		639
	],
	"./hooks/UseSendCode": [
		77828,
		9
	],
	"./hooks/UseSendCode.ts": [
		77828,
		9
	],
	"./hooks/UseTransfer": [
		7155,
		9
	],
	"./hooks/UseTransfer.ts": [
		7155,
		9
	],
	"./hooks/UseUpdateCourierDelivery": [
		28696,
		9
	],
	"./hooks/UseUpdateCourierDelivery.ts": [
		28696,
		9
	],
	"./hooks/UseUserPermissions": [
		85347,
		9
	],
	"./hooks/UseUserPermissions.ts": [
		85347,
		9
	],
	"./hooks/UseValidateSeriesItem": [
		25573,
		9,
		5573
	],
	"./hooks/UseValidateSeriesItem.tsx": [
		25573,
		9,
		5573
	],
	"./hooks/UseViewPickupCode": [
		36525,
		9
	],
	"./hooks/UseViewPickupCode.ts": [
		36525,
		9
	],
	"./hooks/UseViewUploadFiles": [
		87329,
		9
	],
	"./hooks/UseViewUploadFiles.ts": [
		87329,
		9
	],
	"./hooks/core/useEnv": [
		12468,
		9
	],
	"./hooks/core/useEnv.tsx": [
		12468,
		9
	],
	"./hooks/core/useMulticlient": [
		15923,
		9
	],
	"./hooks/core/useMulticlient.tsx": [
		15923,
		9
	],
	"./hooks/index": [
		55405,
		9
	],
	"./hooks/index.ts": [
		55405,
		9
	],
	"./hooks/useComponentVisible": [
		44745,
		9
	],
	"./hooks/useComponentVisible.ts": [
		44745,
		9
	],
	"./hooks/useGetOrderByStatus": [
		66474,
		9,
		6474
	],
	"./hooks/useGetOrderByStatus.ts": [
		66474,
		9,
		6474
	],
	"./hooks/useGetSgsByStatus": [
		61076,
		9
	],
	"./hooks/useGetSgsByStatus/": [
		61076,
		9
	],
	"./hooks/useGetSgsByStatus/clients/useCore": [
		31156,
		9
	],
	"./hooks/useGetSgsByStatus/clients/useCore.ts": [
		31156,
		9
	],
	"./hooks/useGetSgsByStatus/clients/usePrivilege": [
		47764,
		9
	],
	"./hooks/useGetSgsByStatus/clients/usePrivilege.ts": [
		47764,
		9
	],
	"./hooks/useGetSgsByStatus/clients/useSandbox": [
		65268,
		9,
		5268
	],
	"./hooks/useGetSgsByStatus/clients/useSandbox.ts": [
		65268,
		9,
		5268
	],
	"./hooks/useGetSgsByStatus/clients/useWOM": [
		92634,
		9
	],
	"./hooks/useGetSgsByStatus/clients/useWOM.ts": [
		92634,
		9
	],
	"./hooks/useGetSgsByStatus/index": [
		61076,
		9
	],
	"./hooks/useGetSgsByStatus/index.ts": [
		61076,
		9
	],
	"./hooks/useGetSourceInfo": [
		12067,
		9
	],
	"./hooks/useGetSourceInfo.ts": [
		12067,
		9
	],
	"./hooks/useLocalStorage": [
		16728,
		9
	],
	"./hooks/useLocalStorage.ts": [
		16728,
		9
	],
	"./hooks/useMassiveLoadOrders": [
		23298,
		9
	],
	"./hooks/useMassiveLoadOrders.ts": [
		23298,
		9
	],
	"./hooks/useOnClickOutside": [
		85325,
		9
	],
	"./hooks/useOnClickOutside.ts": [
		85325,
		9
	],
	"./hooks/useOutstandingChecker": [
		44004,
		9
	],
	"./hooks/useOutstandingChecker.ts": [
		44004,
		9
	],
	"./hooks/useUpsertUsers": [
		15452,
		9
	],
	"./hooks/useUpsertUsers.ts": [
		15452,
		9
	],
	"./index": [
		67672,
		9
	],
	"./index.css": [
		51174,
		9,
		1174
	],
	"./index.tsx": [
		67672,
		9
	],
	"./interfaces/CommonsInterface": [
		84676,
		9,
		4676
	],
	"./interfaces/CommonsInterface.ts": [
		84676,
		9,
		4676
	],
	"./interfaces/IAlert": [
		61535,
		9,
		1535
	],
	"./interfaces/IAlert.ts": [
		61535,
		9,
		1535
	],
	"./interfaces/IAutoComplete": [
		991,
		9,
		991
	],
	"./interfaces/IAutoComplete.ts": [
		991,
		9,
		991
	],
	"./interfaces/IBarcode": [
		25106,
		9,
		5106
	],
	"./interfaces/IBarcode.ts": [
		25106,
		9,
		5106
	],
	"./interfaces/ICard": [
		44542,
		9,
		4542
	],
	"./interfaces/ICard.ts": [
		44542,
		9,
		4542
	],
	"./interfaces/ICheckbox": [
		90577,
		9,
		577
	],
	"./interfaces/ICheckbox.ts": [
		90577,
		9,
		577
	],
	"./interfaces/IClient": [
		20010,
		9,
		1230
	],
	"./interfaces/IClient.ts": [
		20010,
		9,
		1230
	],
	"./interfaces/ICommons": [
		87924,
		9,
		7924
	],
	"./interfaces/ICommons.ts": [
		87924,
		9,
		7924
	],
	"./interfaces/IContentCelendar": [
		87562,
		9,
		7562
	],
	"./interfaces/IContentCelendar.ts": [
		87562,
		9,
		7562
	],
	"./interfaces/IContext": [
		17633,
		9,
		7633
	],
	"./interfaces/IContext.ts": [
		17633,
		9,
		7633
	],
	"./interfaces/IContextProps": [
		50549,
		9,
		549
	],
	"./interfaces/IContextProps.ts": [
		50549,
		9,
		549
	],
	"./interfaces/IContractor": [
		76173,
		9,
		6173
	],
	"./interfaces/IContractor.ts": [
		76173,
		9,
		6173
	],
	"./interfaces/ICustomFilters": [
		6352,
		9,
		6352
	],
	"./interfaces/ICustomFilters.ts": [
		6352,
		9,
		6352
	],
	"./interfaces/ICustomerOrder": [
		6322,
		9,
		6322
	],
	"./interfaces/ICustomerOrder.ts": [
		6322,
		9,
		6322
	],
	"./interfaces/IDateRangeCalendar": [
		27082,
		9,
		7082
	],
	"./interfaces/IDateRangeCalendar.ts": [
		27082,
		9,
		7082
	],
	"./interfaces/IDocuments": [
		25348,
		9,
		5348
	],
	"./interfaces/IDocuments.ts": [
		25348,
		9,
		5348
	],
	"./interfaces/IElocker": [
		43226,
		9,
		3226
	],
	"./interfaces/IElocker.ts": [
		43226,
		9,
		3226
	],
	"./interfaces/IErrorHandler": [
		22872,
		9,
		2872
	],
	"./interfaces/IErrorHandler.ts": [
		22872,
		9,
		2872
	],
	"./interfaces/IFileCard": [
		1638,
		9,
		1638
	],
	"./interfaces/IFileCard.ts": [
		1638,
		9,
		1638
	],
	"./interfaces/IFileUpload": [
		39290,
		9,
		9290
	],
	"./interfaces/IFileUpload.ts": [
		39290,
		9,
		9290
	],
	"./interfaces/IFilterOrder": [
		53845,
		9,
		3845
	],
	"./interfaces/IFilterOrder.ts": [
		53845,
		9,
		3845
	],
	"./interfaces/IGenerateDocumentButton": [
		43970,
		9,
		3970
	],
	"./interfaces/IGenerateDocumentButton.ts": [
		43970,
		9,
		3970
	],
	"./interfaces/IGrouping": [
		55995,
		9,
		5995
	],
	"./interfaces/IGrouping.ts": [
		55995,
		9,
		5995
	],
	"./interfaces/IImage": [
		12966,
		9,
		2966
	],
	"./interfaces/IImage.tsx": [
		12966,
		9,
		2966
	],
	"./interfaces/IItemsOrder": [
		62295,
		9,
		2295
	],
	"./interfaces/IItemsOrder.ts": [
		62295,
		9,
		2295
	],
	"./interfaces/ILoginBody": [
		63293,
		9,
		3293
	],
	"./interfaces/ILoginBody.ts": [
		63293,
		9,
		3293
	],
	"./interfaces/IMenu": [
		64288,
		9,
		4288
	],
	"./interfaces/IMenu.ts": [
		64288,
		9,
		4288
	],
	"./interfaces/IModal": [
		13504,
		9,
		3504
	],
	"./interfaces/IModal.ts": [
		13504,
		9,
		3504
	],
	"./interfaces/INotification": [
		32217,
		9,
		2217
	],
	"./interfaces/INotification.ts": [
		32217,
		9,
		2217
	],
	"./interfaces/IOrder": [
		97210,
		9,
		7210
	],
	"./interfaces/IOrder.ts": [
		97210,
		9,
		7210
	],
	"./interfaces/IPage": [
		80522,
		7,
		522
	],
	"./interfaces/IPage.ts": [
		80522,
		7,
		522
	],
	"./interfaces/IPagination": [
		8126,
		9,
		8126
	],
	"./interfaces/IPagination.ts": [
		8126,
		9,
		8126
	],
	"./interfaces/IProcessEnv": [
		32172,
		9,
		2172
	],
	"./interfaces/IProcessEnv.ts": [
		32172,
		9,
		2172
	],
	"./interfaces/IProcessProductsList": [
		20891,
		9,
		891
	],
	"./interfaces/IProcessProductsList.ts": [
		20891,
		9,
		891
	],
	"./interfaces/IProductCount": [
		56802,
		9,
		6802
	],
	"./interfaces/IProductCount.ts": [
		56802,
		9,
		6802
	],
	"./interfaces/IProductDetail": [
		24286,
		9,
		4286
	],
	"./interfaces/IProductDetail.ts": [
		24286,
		9,
		4286
	],
	"./interfaces/IProductOrderDetail": [
		93582,
		9,
		3582
	],
	"./interfaces/IProductOrderDetail.ts": [
		93582,
		9,
		3582
	],
	"./interfaces/IProfileUser": [
		1254,
		9,
		1254
	],
	"./interfaces/IProfileUser.ts": [
		1254,
		9,
		1254
	],
	"./interfaces/IPropsButton": [
		68742,
		9,
		8742
	],
	"./interfaces/IPropsButton.ts": [
		68742,
		9,
		8742
	],
	"./interfaces/IPropsInput": [
		29099,
		9,
		9099
	],
	"./interfaces/IPropsInput.ts": [
		29099,
		9,
		9099
	],
	"./interfaces/IQRCode": [
		86130,
		9,
		6130
	],
	"./interfaces/IQRCode.ts": [
		86130,
		9,
		6130
	],
	"./interfaces/IRadioButton": [
		8751,
		9,
		519
	],
	"./interfaces/IRadioButton.tsx": [
		8751,
		9,
		519
	],
	"./interfaces/IRequestService": [
		63383,
		9,
		3383
	],
	"./interfaces/IRequestService.ts": [
		63383,
		9,
		3383
	],
	"./interfaces/IResourcePermission": [
		20919,
		9,
		919
	],
	"./interfaces/IResourcePermission.ts": [
		20919,
		9,
		919
	],
	"./interfaces/IResponseAttachFile": [
		66623,
		9,
		6623
	],
	"./interfaces/IResponseAttachFile.ts": [
		66623,
		9,
		6623
	],
	"./interfaces/IResponseService": [
		98353,
		9,
		8353
	],
	"./interfaces/IResponseService.ts": [
		98353,
		9,
		8353
	],
	"./interfaces/IRoute": [
		23305,
		9,
		3305
	],
	"./interfaces/IRoute.ts": [
		23305,
		9,
		3305
	],
	"./interfaces/IRulesJsonEngine": [
		61250,
		9,
		1250
	],
	"./interfaces/IRulesJsonEngine.ts": [
		61250,
		9,
		1250
	],
	"./interfaces/IScanner": [
		32752,
		9,
		2752
	],
	"./interfaces/IScanner.ts": [
		32752,
		9,
		2752
	],
	"./interfaces/IScannerInput": [
		75406,
		9,
		5406
	],
	"./interfaces/IScannerInput.ts": [
		75406,
		9,
		5406
	],
	"./interfaces/ISearchForm": [
		52236,
		9,
		2236
	],
	"./interfaces/ISearchForm.ts": [
		52236,
		9,
		2236
	],
	"./interfaces/ISearchResults": [
		22684,
		9,
		2684
	],
	"./interfaces/ISearchResults.ts": [
		22684,
		9,
		2684
	],
	"./interfaces/ISearchSource": [
		96506,
		9,
		6506
	],
	"./interfaces/ISearchSource.ts": [
		96506,
		9,
		6506
	],
	"./interfaces/ISelectBox": [
		98064,
		9,
		8064
	],
	"./interfaces/ISelectBox.ts": [
		98064,
		9,
		8064
	],
	"./interfaces/ISendCode": [
		93077,
		9,
		3077
	],
	"./interfaces/ISendCode.ts": [
		93077,
		9,
		3077
	],
	"./interfaces/ISendQR": [
		31709,
		9,
		1709
	],
	"./interfaces/ISendQR.ts": [
		31709,
		9,
		1709
	],
	"./interfaces/ISeries": [
		49976,
		9,
		9976
	],
	"./interfaces/ISeries.ts": [
		49976,
		9,
		9976
	],
	"./interfaces/IShippingGroup": [
		15185,
		9,
		5185
	],
	"./interfaces/IShippingGroup.ts": [
		15185,
		9,
		5185
	],
	"./interfaces/IShippingGroupAction": [
		47769,
		9,
		7769
	],
	"./interfaces/IShippingGroupAction.ts": [
		47769,
		9,
		7769
	],
	"./interfaces/ISkeleton": [
		39524,
		9,
		9524
	],
	"./interfaces/ISkeleton.ts": [
		39524,
		9,
		9524
	],
	"./interfaces/ISortOrders": [
		44410,
		9,
		4410
	],
	"./interfaces/ISortOrders.ts": [
		44410,
		9,
		4410
	],
	"./interfaces/ISource": [
		2615,
		9,
		2615
	],
	"./interfaces/ISource.ts": [
		2615,
		9,
		2615
	],
	"./interfaces/ITagInfoCustomer": [
		72404,
		9,
		2404
	],
	"./interfaces/ITagInfoCustomer.ts": [
		72404,
		9,
		2404
	],
	"./interfaces/ITagPrintContent": [
		20449,
		9,
		449
	],
	"./interfaces/ITagPrintContent.ts": [
		20449,
		9,
		449
	],
	"./interfaces/ITheme": [
		14304,
		9,
		4304
	],
	"./interfaces/ITheme.ts": [
		14304,
		9,
		4304
	],
	"./interfaces/IUser": [
		68350,
		9,
		8350
	],
	"./interfaces/IUser.ts": [
		68350,
		9,
		8350
	],
	"./interfaces/ProcessEnvInterface": [
		24535,
		9,
		4535
	],
	"./interfaces/ProcessEnvInterface.ts": [
		24535,
		9,
		4535
	],
	"./logo.svg": [
		31100,
		1,
		1100
	],
	"./mocks/get_ticket": [
		20673,
		9
	],
	"./mocks/get_ticket/": [
		20673,
		9
	],
	"./mocks/get_ticket/getTicket": [
		10608,
		3
	],
	"./mocks/get_ticket/getTicket.json": [
		10608,
		3
	],
	"./mocks/get_ticket/index": [
		20673,
		9
	],
	"./mocks/get_ticket/index.ts": [
		20673,
		9
	],
	"./overrides/layout": [
		77511,
		9
	],
	"./overrides/layout/": [
		77511,
		9
	],
	"./overrides/layout/entel": [
		33622,
		3
	],
	"./overrides/layout/entel.json": [
		33622,
		3
	],
	"./overrides/layout/index": [
		77511,
		9
	],
	"./overrides/layout/index.ts": [
		77511,
		9
	],
	"./overrides/layout/omnix": [
		13313,
		3
	],
	"./overrides/layout/omnix.json": [
		13313,
		3
	],
	"./overrides/layout/privilege": [
		34566,
		3
	],
	"./overrides/layout/privilege.json": [
		34566,
		3
	],
	"./overrides/layout/sandbox": [
		52837,
		3
	],
	"./overrides/layout/sandbox.json": [
		52837,
		3
	],
	"./overrides/layout/shiperto": [
		45334,
		3
	],
	"./overrides/layout/shiperto.json": [
		45334,
		3
	],
	"./overrides/layout/wom": [
		57013,
		3
	],
	"./overrides/layout/wom.json": [
		57013,
		3
	],
	"./overrides/theme/entel/Routes/List/RouteList": [
		57758,
		9
	],
	"./overrides/theme/entel/Routes/List/RouteList.tsx": [
		57758,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Calendar/DateRangeCalendar": [
		30324,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Calendar/DateRangeCalendar.tsx": [
		30324,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Error/ErrorHandler": [
		69839,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Error/ErrorHandler.styled": [
		69165,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Error/ErrorHandler.styled.ts": [
		69165,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Error/ErrorHandler.tsx": [
		69839,
		9
	],
	"./overrides/theme/entel/base/components/Commons/LabelSwitch/LabelSwitch": [
		13434,
		9
	],
	"./overrides/theme/entel/base/components/Commons/LabelSwitch/LabelSwitch.style": [
		70676,
		9
	],
	"./overrides/theme/entel/base/components/Commons/LabelSwitch/LabelSwitch.style.ts": [
		70676,
		9
	],
	"./overrides/theme/entel/base/components/Commons/LabelSwitch/LabelSwitch.tsx": [
		13434,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Loading/Loading": [
		18392,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Loading/Loading.tsx": [
		18392,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Notifications/Notification": [
		25499,
		9,
		5499
	],
	"./overrides/theme/entel/base/components/Commons/Notifications/Notification.style": [
		87273,
		9,
		7273
	],
	"./overrides/theme/entel/base/components/Commons/Notifications/Notification.style.ts": [
		87273,
		9,
		7273
	],
	"./overrides/theme/entel/base/components/Commons/Notifications/Notification.tsx": [
		25499,
		9,
		5499
	],
	"./overrides/theme/entel/base/components/Commons/Pagination/Paginate": [
		66011,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Pagination/Paginate.tsx": [
		66011,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Pagination/Pagination.styled": [
		54263,
		9
	],
	"./overrides/theme/entel/base/components/Commons/Pagination/Pagination.styled.ts": [
		54263,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/CardOrder/CardOrdeItem": [
		96102,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/CardOrder/CardOrdeItem.tsx": [
		96102,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/CardOrder/CardOrderItem.styled": [
		92813,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/CardOrder/CardOrderItem.styled.ts": [
		92813,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/ContentCalendar/ButtonOptionCalendar": [
		9235,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/ContentCalendar/ButtonOptionCalendar.tsx": [
		9235,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar": [
		86690,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.style": [
		20866,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.style.ts": [
		20866,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.tsx": [
		86690,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/OrderFilterDate": [
		24071,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/OrderFilterDate.style": [
		73701,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/OrderFilterDate.style.ts": [
		73701,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/FilterDate/OrderFilterDate.tsx": [
		24071,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/OrderList": [
		85489,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/OrderList.tsx": [
		85489,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/Sort/SortOrder": [
		83019,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/Sort/SortOrder.styled": [
		28648,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/Sort/SortOrder.styled.ts": [
		28648,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/Sort/SortOrder.tsx": [
		83019,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/hooks/UseChekedOrderList": [
		76755,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/hooks/UseChekedOrderList.ts": [
		76755,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/hooks/UseConditionalsGroupOrder": [
		35060,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/hooks/UseConditionalsGroupOrder.ts": [
		35060,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/styles/OrderList.style": [
		23749,
		9
	],
	"./overrides/theme/entel/base/components/Core/Order/styles/OrderList.style.ts": [
		23749,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/CenterSide": [
		40978,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/CenterSide.tsx": [
		40978,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/LeftSide": [
		83555,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/LeftSide.tsx": [
		83555,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/RightSide": [
		40374,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/RightSide.tsx": [
		40374,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/TagPrintBody": [
		95730,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintBody/TagPrintBody.tsx": [
		95730,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintButton": [
		68100,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/TagPrintButton.tsx": [
		68100,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/styles/TagPrintBody.style": [
		25907,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/styles/TagPrintBody.style.ts": [
		25907,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/styles/TagPrintContent.style": [
		77258,
		9
	],
	"./overrides/theme/entel/base/components/OrderDetail/TagPrint/styles/TagPrintContent.style.ts": [
		77258,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/SearchForm": [
		72858,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/SearchForm.tsx": [
		72858,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/SearchFormUsers": [
		43738,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/SearchFormUsers.tsx": [
		43738,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/styles/SearchForm.style": [
		98290,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/styles/SearchForm.style.ts": [
		98290,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/styles/SearchFormUsers.style": [
		5821,
		9
	],
	"./overrides/theme/entel/base/components/SearchForm/styles/SearchFormUsers.style.ts": [
		5821,
		9
	],
	"./overrides/theme/entel/base/components/Summary/SummaryOption/CardOption": [
		44956,
		9
	],
	"./overrides/theme/entel/base/components/Summary/SummaryOption/CardOption.tsx": [
		44956,
		9
	],
	"./overrides/theme/entel/base/components/Summary/SummaryOptions": [
		20020,
		9
	],
	"./overrides/theme/entel/base/components/Summary/SummaryOptions.tsx": [
		20020,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/Header": [
		32037,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/Header.tsx": [
		32037,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/MainLayout": [
		48981,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/MainLayout.tsx": [
		48981,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/Sidebar": [
		74172,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/Sidebar.tsx": [
		74172,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/styles/Header.style": [
		35597,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/styles/Header.style.ts": [
		35597,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/styles/MainLayout.style": [
		16585,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/styles/MainLayout.style.ts": [
		16585,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/styles/Sidebar.style": [
		50504,
		9
	],
	"./overrides/theme/entel/base/components/Theme/Layout/Main/styles/Sidebar.style.ts": [
		50504,
		9
	],
	"./overrides/theme/entel/base/components/User/Login/LoginForm": [
		31316,
		9,
		9381,
		1316
	],
	"./overrides/theme/entel/base/components/User/Login/LoginForm.style": [
		69968,
		9,
		9968
	],
	"./overrides/theme/entel/base/components/User/Login/LoginForm.style.ts": [
		69968,
		9,
		9968
	],
	"./overrides/theme/entel/base/components/User/Login/LoginForm.tsx": [
		31316,
		9,
		9381,
		1316
	],
	"./overrides/theme/entel/base/hooks": [
		43643,
		9
	],
	"./overrides/theme/entel/base/hooks/": [
		43643,
		9
	],
	"./overrides/theme/entel/base/hooks/index": [
		43643,
		9
	],
	"./overrides/theme/entel/base/hooks/index.ts": [
		43643,
		9
	],
	"./overrides/theme/entel/base/hooks/useGetSgsByStatus": [
		74495,
		9
	],
	"./overrides/theme/entel/base/hooks/useGetSgsByStatus.tsx": [
		74495,
		9
	],
	"./overrides/theme/entel/base/hooks/useOrderGrouped": [
		25435,
		9
	],
	"./overrides/theme/entel/base/hooks/useOrderGrouped.tsx": [
		25435,
		9
	],
	"./overrides/theme/entel/base/hooks/useServicesOSRM": [
		67228,
		9
	],
	"./overrides/theme/entel/base/hooks/useServicesOSRM.tsx": [
		67228,
		9
	],
	"./overrides/theme/entel/base/hooks/useUpdateSGCustom": [
		30501,
		9
	],
	"./overrides/theme/entel/base/hooks/useUpdateSGCustom.ts": [
		30501,
		9
	],
	"./overrides/theme/entel/base/pages/BulkLoadScreen/BulkLoadScreen": [
		10654,
		9
	],
	"./overrides/theme/entel/base/pages/BulkLoadScreen/BulkLoadScreen.style": [
		83372,
		9
	],
	"./overrides/theme/entel/base/pages/BulkLoadScreen/BulkLoadScreen.style.ts": [
		83372,
		9
	],
	"./overrides/theme/entel/base/pages/BulkLoadScreen/BulkLoadScreen.tsx": [
		10654,
		9
	],
	"./overrides/theme/entel/base/pages/ChartsScreen/ChartsScreen": [
		92550,
		9
	],
	"./overrides/theme/entel/base/pages/ChartsScreen/ChartsScreen.tsx": [
		92550,
		9
	],
	"./overrides/theme/entel/base/pages/ChartsScreen/styles/ChartsScreen.style": [
		91685,
		9
	],
	"./overrides/theme/entel/base/pages/ChartsScreen/styles/ChartsScreen.style.ts": [
		91685,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/Carousel": [
		55982,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/Carousel.tsx": [
		55982,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/Item": [
		77707,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/Item.tsx": [
		77707,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailModalAction": [
		15368,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailModalAction.tsx": [
		15368,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailProductList": [
		30414,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailProductList.tsx": [
		30414,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailScreen": [
		7673,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailScreen.tsx": [
		7673,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailTraces": [
		67858,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetailTraces.tsx": [
		67858,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetails": [
		88541,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderDetails.tsx": [
		88541,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderInfoPrint": [
		88675,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/OrderInfoPrint.tsx": [
		88675,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/styles/OrderDetail.style": [
		81854,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/styles/OrderDetail.style.ts": [
		81854,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/styles/OrderDetailModalAction.style": [
		18877,
		9
	],
	"./overrides/theme/entel/base/pages/DetailOrderScreens/styles/OrderDetailModalAction.style.ts": [
		18877,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/DashBoardScreen": [
		72177,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/DashBoardScreen.tsx": [
		72177,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/DashboardAside": [
		84493,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/DashboardAside.tsx": [
		84493,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/DashboardContent": [
		73825,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/DashboardContent.tsx": [
		73825,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/styles/DashboardScreen.style": [
		43211,
		9
	],
	"./overrides/theme/entel/base/pages/HomeScreens/HomeScreen/styles/DashboardScreen.style.ts": [
		43211,
		9
	],
	"./overrides/theme/entel/base/pages/OrderScreens/OrderScreen": [
		68741,
		9
	],
	"./overrides/theme/entel/base/pages/OrderScreens/OrderScreen.style": [
		80366,
		9
	],
	"./overrides/theme/entel/base/pages/OrderScreens/OrderScreen.style.ts": [
		80366,
		9
	],
	"./overrides/theme/entel/base/pages/OrderScreens/OrderScreen.tsx": [
		68741,
		9
	],
	"./overrides/theme/entel/base/pages/ReportScreens/ReportScreen": [
		21909,
		9
	],
	"./overrides/theme/entel/base/pages/ReportScreens/ReportScreen.tsx": [
		21909,
		9
	],
	"./overrides/theme/entel/base/pages/SearchResults/SearchResultsScreen": [
		53553,
		9
	],
	"./overrides/theme/entel/base/pages/SearchResults/SearchResultsScreen.style": [
		77113,
		9
	],
	"./overrides/theme/entel/base/pages/SearchResults/SearchResultsScreen.style.ts": [
		77113,
		9
	],
	"./overrides/theme/entel/base/pages/SearchResults/SearchResultsScreen.tsx": [
		53553,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/DetailUserScreen": [
		93089,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/DetailUserScreen.tsx": [
		93089,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/ListUsersScreen": [
		77777,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/ListUsersScreen.tsx": [
		77777,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/NewUserScreen": [
		33244,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/NewUserScreen.tsx": [
		33244,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/PermissionList": [
		91497,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/PermissionList.tsx": [
		91497,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/RolePermissionList": [
		81756,
		3
	],
	"./overrides/theme/entel/base/pages/UsersScreens/RolePermissionList.json": [
		81756,
		3
	],
	"./overrides/theme/entel/base/pages/UsersScreens/styles/DetailUserScreen.style": [
		99750,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/styles/DetailUserScreen.style.ts": [
		99750,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/styles/ListUsersScreen.style": [
		54977,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/styles/ListUsersScreen.style.ts": [
		54977,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/styles/NewUserScreen.style": [
		19318,
		9
	],
	"./overrides/theme/entel/base/pages/UsersScreens/styles/NewUserScreen.style.ts": [
		19318,
		9
	],
	"./overrides/theme/entel/base/services/ShippingGroupService": [
		19716,
		9
	],
	"./overrides/theme/entel/base/services/ShippingGroupService.ts": [
		19716,
		9
	],
	"./overrides/theme/entel/base/translates/translation": [
		77189,
		3
	],
	"./overrides/theme/entel/base/translates/translation.json": [
		77189,
		3
	],
	"./overrides/theme/entel_old/base/Pages/DetailOrderScreens/Confirm/ConfirmOrderScreen": [
		93764,
		9,
		3764
	],
	"./overrides/theme/entel_old/base/Pages/DetailOrderScreens/Confirm/ConfirmOrderScreen.tsx": [
		93764,
		9,
		3764
	],
	"./overrides/theme/entel_old/base/Pages/DetailOrderScreens/Confirm/PickingReducer": [
		72117,
		9,
		2117
	],
	"./overrides/theme/entel_old/base/Pages/DetailOrderScreens/Confirm/PickingReducer.ts": [
		72117,
		9,
		2117
	],
	"./overrides/theme/entel_old/base/Pages/DetailOrderScreens/Confirm/UseConfirmOrder": [
		20971,
		9,
		971
	],
	"./overrides/theme/entel_old/base/Pages/DetailOrderScreens/Confirm/UseConfirmOrder.ts": [
		20971,
		9,
		971
	],
	"./overrides/theme/entel_old/base/Routes/List/RouteList": [
		7795,
		9,
		7795
	],
	"./overrides/theme/entel_old/base/Routes/List/RouteList.tsx": [
		7795,
		9,
		7795
	],
	"./overrides/theme/entel_old/base/components/Core/ProductTransition/ScannerlTransition": [
		5318,
		9,
		5318
	],
	"./overrides/theme/entel_old/base/components/Core/ProductTransition/ScannerlTransition.tsx": [
		5318,
		9,
		5318
	],
	"./overrides/theme/privilege/base/Pages/DetailOrderScreens/Confirm/ConfirmOrderScreen": [
		57936,
		9
	],
	"./overrides/theme/privilege/base/Pages/DetailOrderScreens/Confirm/ConfirmOrderScreen.tsx": [
		57936,
		9
	],
	"./overrides/theme/privilege/base/Pages/DetailOrderScreens/Confirm/ProductItemRow": [
		11161,
		9
	],
	"./overrides/theme/privilege/base/Pages/DetailOrderScreens/Confirm/ProductItemRow.tsx": [
		11161,
		9
	],
	"./overrides/theme/privilege/base/Pages/DetailOrderScreens/Confirm/useConfirmOrder": [
		83384,
		9
	],
	"./overrides/theme/privilege/base/Pages/DetailOrderScreens/Confirm/useConfirmOrder.tsx": [
		83384,
		9
	],
	"./overrides/theme/privilege/base/Pages/DetailOrderScreens/Transit/TransitScreen": [
		35361,
		9
	],
	"./overrides/theme/privilege/base/Pages/DetailOrderScreens/Transit/TransitScreen.tsx": [
		35361,
		9
	],
	"./overrides/theme/privilege/base/Pages/DetailOrderScreens/Transit/UseTransitOrder": [
		34860,
		9
	],
	"./overrides/theme/privilege/base/Pages/DetailOrderScreens/Transit/UseTransitOrder.ts": [
		34860,
		9
	],
	"./overrides/theme/privilege/base/routes/List/RouteList": [
		18609,
		9
	],
	"./overrides/theme/privilege/base/routes/List/RouteList.ts": [
		18609,
		9
	],
	"./overrides/theme/sandbox/base/Hooks/Media/useFormConfig": [
		58662,
		9
	],
	"./overrides/theme/sandbox/base/Hooks/Media/useFormConfig.tsx": [
		58662,
		9
	],
	"./overrides/theme/sandbox/base/Hooks/Order/useOrderAction": [
		6525,
		9
	],
	"./overrides/theme/sandbox/base/Hooks/Order/useOrderAction.tsx": [
		6525,
		9
	],
	"./overrides/theme/sandbox/base/Pages/DetailOrderScreens/OrderDetailScreen": [
		86374,
		9
	],
	"./overrides/theme/sandbox/base/Pages/DetailOrderScreens/OrderDetailScreen.tsx": [
		86374,
		9
	],
	"./overrides/theme/sandbox/base/Routes/List/RouteList": [
		78079,
		9
	],
	"./overrides/theme/sandbox/base/Routes/List/RouteList.tsx": [
		78079,
		9
	],
	"./overrides/theme/shiperto/Routes/List/RouteList": [
		45455,
		9
	],
	"./overrides/theme/shiperto/Routes/List/RouteList.tsx": [
		45455,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Calendar/DateRangeCalendar": [
		30814,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Calendar/DateRangeCalendar.tsx": [
		30814,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Error/ErrorHandler": [
		34385,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Error/ErrorHandler.styled": [
		46838,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Error/ErrorHandler.styled.ts": [
		46838,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Error/ErrorHandler.tsx": [
		34385,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/LabelSwitch/LabelSwitch": [
		18476,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/LabelSwitch/LabelSwitch.style": [
		33393,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/LabelSwitch/LabelSwitch.style.ts": [
		33393,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/LabelSwitch/LabelSwitch.tsx": [
		18476,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Notifications/Notification": [
		28823,
		9,
		8823
	],
	"./overrides/theme/shiperto/base/components/Commons/Notifications/Notification.style": [
		47236,
		9,
		7236
	],
	"./overrides/theme/shiperto/base/components/Commons/Notifications/Notification.style.ts": [
		47236,
		9,
		7236
	],
	"./overrides/theme/shiperto/base/components/Commons/Notifications/Notification.tsx": [
		28823,
		9,
		8823
	],
	"./overrides/theme/shiperto/base/components/Commons/Pagination/Paginate": [
		62139,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Pagination/Paginate.tsx": [
		62139,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Pagination/Pagination.styled": [
		28198,
		9
	],
	"./overrides/theme/shiperto/base/components/Commons/Pagination/Pagination.styled.ts": [
		28198,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/CardOrder/CardOrdeItem": [
		99982,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/CardOrder/CardOrdeItem.tsx": [
		99982,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/CardOrder/CardOrderItem.styled": [
		69773,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/CardOrder/CardOrderItem.styled.ts": [
		69773,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/ContentCalendar/ButtonOptionCalendar": [
		49499,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/ContentCalendar/ButtonOptionCalendar.tsx": [
		49499,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar": [
		14659,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.style": [
		16576,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.style.ts": [
		16576,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/ContentCalendar/ContentCalendar.tsx": [
		14659,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/OrderFilterDate": [
		86589,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/OrderFilterDate.style": [
		95112,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/OrderFilterDate.style.ts": [
		95112,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/FilterDate/OrderFilterDate.tsx": [
		86589,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/OrderList": [
		31011,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/OrderList.tsx": [
		31011,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/Sort/SortOrder": [
		31708,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/Sort/SortOrder.styled": [
		69464,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/Sort/SortOrder.styled.ts": [
		69464,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/Sort/SortOrder.tsx": [
		31708,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/hooks/UseChekedOrderList": [
		53249,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/hooks/UseChekedOrderList.ts": [
		53249,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/hooks/UseConditionalsGroupOrder": [
		33605,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/hooks/UseConditionalsGroupOrder.ts": [
		33605,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/styles/OrderList.style": [
		39313,
		9
	],
	"./overrides/theme/shiperto/base/components/Core/Order/styles/OrderList.style.ts": [
		39313,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/CenterSide": [
		70907,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/CenterSide.tsx": [
		70907,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/LeftSide": [
		65657,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/LeftSide.tsx": [
		65657,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/RightSide": [
		62599,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/RightSide.tsx": [
		62599,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/TagPrintBody": [
		31572,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintBody/TagPrintBody.tsx": [
		31572,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintButton": [
		63899,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/TagPrintButton.tsx": [
		63899,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/styles/TagPrintBody.style": [
		85861,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/styles/TagPrintBody.style.ts": [
		85861,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/styles/TagPrintContent.style": [
		74059,
		9
	],
	"./overrides/theme/shiperto/base/components/OrderDetail/TagPrint/styles/TagPrintContent.style.ts": [
		74059,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/SearchForm": [
		24751,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/SearchForm.tsx": [
		24751,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/SearchFormUsers": [
		62848,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/SearchFormUsers.tsx": [
		62848,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/styles/SearchForm.style": [
		760,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/styles/SearchForm.style.ts": [
		760,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/styles/SearchFormUsers.style": [
		91498,
		9
	],
	"./overrides/theme/shiperto/base/components/SearchForm/styles/SearchFormUsers.style.ts": [
		91498,
		9
	],
	"./overrides/theme/shiperto/base/components/Summary/SummaryOption/CardOption": [
		62079,
		9
	],
	"./overrides/theme/shiperto/base/components/Summary/SummaryOption/CardOption.tsx": [
		62079,
		9
	],
	"./overrides/theme/shiperto/base/components/Summary/SummaryOptions": [
		22958,
		9
	],
	"./overrides/theme/shiperto/base/components/Summary/SummaryOptions.tsx": [
		22958,
		9
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/Header": [
		6121,
		9
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/Header.tsx": [
		6121,
		9
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/MainLayout": [
		26364,
		9
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/MainLayout.tsx": [
		26364,
		9
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/Sidebar": [
		42265,
		9
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/Sidebar.tsx": [
		42265,
		9
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/styles/Header.style": [
		52658,
		9
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/styles/Header.style.ts": [
		52658,
		9
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/styles/MainLayout.style": [
		50200,
		9
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/styles/MainLayout.style.ts": [
		50200,
		9
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/styles/Sidebar.style": [
		84879,
		9
	],
	"./overrides/theme/shiperto/base/components/Theme/Layout/Main/styles/Sidebar.style.ts": [
		84879,
		9
	],
	"./overrides/theme/shiperto/base/components/User/Login/LoginForm": [
		66898,
		9,
		9381,
		6898
	],
	"./overrides/theme/shiperto/base/components/User/Login/LoginForm.style": [
		95175,
		9,
		5175
	],
	"./overrides/theme/shiperto/base/components/User/Login/LoginForm.style.ts": [
		95175,
		9,
		5175
	],
	"./overrides/theme/shiperto/base/components/User/Login/LoginForm.tsx": [
		66898,
		9,
		9381,
		6898
	],
	"./overrides/theme/shiperto/base/hooks": [
		15031,
		9
	],
	"./overrides/theme/shiperto/base/hooks/": [
		15031,
		9
	],
	"./overrides/theme/shiperto/base/hooks/index": [
		15031,
		9
	],
	"./overrides/theme/shiperto/base/hooks/index.ts": [
		15031,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useGetSgsByStatus": [
		88600,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useGetSgsByStatus.tsx": [
		88600,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useOrderGrouped": [
		80995,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useOrderGrouped.tsx": [
		80995,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useServicesOSRM": [
		36046,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useServicesOSRM.tsx": [
		36046,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useUpdateSGCustom": [
		91923,
		9
	],
	"./overrides/theme/shiperto/base/hooks/useUpdateSGCustom.ts": [
		91923,
		9
	],
	"./overrides/theme/shiperto/base/pages/BulkLoadScreen/BulkLoadScreen": [
		55020,
		9
	],
	"./overrides/theme/shiperto/base/pages/BulkLoadScreen/BulkLoadScreen.style": [
		60868,
		9
	],
	"./overrides/theme/shiperto/base/pages/BulkLoadScreen/BulkLoadScreen.style.ts": [
		60868,
		9
	],
	"./overrides/theme/shiperto/base/pages/BulkLoadScreen/BulkLoadScreen.tsx": [
		55020,
		9
	],
	"./overrides/theme/shiperto/base/pages/ChartsScreen/ChartsScreen": [
		50404,
		9
	],
	"./overrides/theme/shiperto/base/pages/ChartsScreen/ChartsScreen.tsx": [
		50404,
		9
	],
	"./overrides/theme/shiperto/base/pages/ChartsScreen/styles/ChartsScreen.style": [
		4717,
		9
	],
	"./overrides/theme/shiperto/base/pages/ChartsScreen/styles/ChartsScreen.style.ts": [
		4717,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/Carousel": [
		20090,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/Carousel.tsx": [
		20090,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/Item": [
		54585,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/Item.tsx": [
		54585,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailModalAction": [
		90517,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailModalAction.tsx": [
		90517,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailProductList": [
		45159,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailProductList.tsx": [
		45159,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailScreen": [
		27171,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailScreen.tsx": [
		27171,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailTraces": [
		26561,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetailTraces.tsx": [
		26561,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetails": [
		53935,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderDetails.tsx": [
		53935,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderInfoPrint": [
		12993,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/OrderInfoPrint.tsx": [
		12993,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/styles/OrderDetail.style": [
		65547,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/styles/OrderDetail.style.ts": [
		65547,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/styles/OrderDetailModalAction.style": [
		97667,
		9
	],
	"./overrides/theme/shiperto/base/pages/DetailOrderScreens/styles/OrderDetailModalAction.style.ts": [
		97667,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/DashBoardScreen": [
		81573,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/DashBoardScreen.tsx": [
		81573,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/DashboardAside": [
		17806,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/DashboardAside.tsx": [
		17806,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/DashboardContent": [
		56963,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/DashboardContent.tsx": [
		56963,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/styles/DashboardScreen.style": [
		63061,
		9
	],
	"./overrides/theme/shiperto/base/pages/HomeScreens/HomeScreen/styles/DashboardScreen.style.ts": [
		63061,
		9
	],
	"./overrides/theme/shiperto/base/pages/OrderScreens/OrderScreen": [
		24889,
		9
	],
	"./overrides/theme/shiperto/base/pages/OrderScreens/OrderScreen.style": [
		15133,
		9
	],
	"./overrides/theme/shiperto/base/pages/OrderScreens/OrderScreen.style.ts": [
		15133,
		9
	],
	"./overrides/theme/shiperto/base/pages/OrderScreens/OrderScreen.tsx": [
		24889,
		9
	],
	"./overrides/theme/shiperto/base/pages/ReportScreens/ReportScreen": [
		11084,
		9
	],
	"./overrides/theme/shiperto/base/pages/ReportScreens/ReportScreen.tsx": [
		11084,
		9
	],
	"./overrides/theme/shiperto/base/pages/SearchResults/SearchResultsScreen": [
		31727,
		9
	],
	"./overrides/theme/shiperto/base/pages/SearchResults/SearchResultsScreen.style": [
		18565,
		9
	],
	"./overrides/theme/shiperto/base/pages/SearchResults/SearchResultsScreen.style.ts": [
		18565,
		9
	],
	"./overrides/theme/shiperto/base/pages/SearchResults/SearchResultsScreen.tsx": [
		31727,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/DetailUserScreen": [
		22569,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/DetailUserScreen.tsx": [
		22569,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/ListUsersScreen": [
		34953,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/ListUsersScreen.tsx": [
		34953,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/NewUserScreen": [
		7532,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/NewUserScreen.tsx": [
		7532,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/PermissionList": [
		34563,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/PermissionList.tsx": [
		34563,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/RolePermissionList": [
		60683,
		3
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/RolePermissionList.json": [
		60683,
		3
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/styles/DetailUserScreen.style": [
		92432,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/styles/DetailUserScreen.style.ts": [
		92432,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/styles/ListUsersScreen.style": [
		7832,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/styles/ListUsersScreen.style.ts": [
		7832,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/styles/NewUserScreen.style": [
		77781,
		9
	],
	"./overrides/theme/shiperto/base/pages/UsersScreens/styles/NewUserScreen.style.ts": [
		77781,
		9
	],
	"./overrides/theme/shiperto/base/services/ShippingGroupService": [
		43301,
		9
	],
	"./overrides/theme/shiperto/base/services/ShippingGroupService.ts": [
		43301,
		9
	],
	"./overrides/theme/shiperto/base/translates/translation": [
		86948,
		3
	],
	"./overrides/theme/shiperto/base/translates/translation.json": [
		86948,
		3
	],
	"./overrides/theme/wom/base/Pages/Contractor/Dashboard/ContractorDashboardScreen": [
		76863,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/Dashboard/ContractorDashboardScreen.tsx": [
		76863,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Installation/Complete/CompleteSreen": [
		23785,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Installation/Complete/CompleteSreen.tsx": [
		23785,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Installation/Incomplete/IncompleteSreen": [
		15835,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Installation/Incomplete/IncompleteSreen.tsx": [
		15835,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Installation/New/NewScreen.styled": [
		56131,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Installation/New/NewScreen.styled.ts": [
		56131,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Installation/New/NewSreen": [
		29562,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Installation/New/NewSreen.tsx": [
		29562,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Reception/New/NewScreen.styled": [
		84764,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Reception/New/NewScreen.styled.ts": [
		84764,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Reception/New/NewSreen": [
		95228,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Reception/New/NewSreen.tsx": [
		95228,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Reception/Other/OtherSreen": [
		46401,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Reception/Other/OtherSreen.tsx": [
		46401,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/OrderScreens/ContractorOrderScreen": [
		16623,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/OrderScreens/ContractorOrderScreen.tsx": [
		16623,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/SearchResults/SearchResultsScreen": [
		28756,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/SearchResults/SearchResultsScreen.tsx": [
		28756,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/SubStatus/ContractorSubStatusScreen": [
		63187,
		9
	],
	"./overrides/theme/wom/base/Pages/Contractor/SubStatus/ContractorSubStatusScreen.tsx": [
		63187,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Closed/ClosedScreen": [
		49118,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Closed/ClosedScreen.tsx": [
		49118,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Confirm/ConfirmOrderScreen": [
		94196,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Confirm/ConfirmOrderScreen.tsx": [
		94196,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Confirm/UseConfirmOrder": [
		51525,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Confirm/UseConfirmOrder.ts": [
		51525,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Custom/OrderDetailScreen": [
		3439,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Custom/OrderDetailScreen.tsx": [
		3439,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Delivered/DeliveredSreen": [
		34651,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Delivered/DeliveredSreen.tsx": [
		34651,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Delivery/DeliveryScreen": [
		13877,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Delivery/DeliveryScreen.tsx": [
		13877,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Package/PackageScreen": [
		56195,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Package/PackageScreen.tsx": [
		56195,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Pickup/PickupScreen": [
		54522,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Pickup/PickupScreen.tsx": [
		54522,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Transit/TransitScreen": [
		502,
		9
	],
	"./overrides/theme/wom/base/Pages/DetailOrderScreens/Transit/TransitScreen.tsx": [
		502,
		9
	],
	"./overrides/theme/wom/base/Pages/HomeScreens/HomeScreen/DashBoardScreen": [
		58633,
		9
	],
	"./overrides/theme/wom/base/Pages/HomeScreens/HomeScreen/DashBoardScreen.tsx": [
		58633,
		9
	],
	"./overrides/theme/wom/base/Pages/OrderScreens/OrderScreen": [
		15330,
		9
	],
	"./overrides/theme/wom/base/Pages/OrderScreens/OrderScreen.tsx": [
		15330,
		9
	],
	"./overrides/theme/wom/base/Pages/SearchResults/SearchResultsScreen": [
		68110,
		9
	],
	"./overrides/theme/wom/base/Pages/SearchResults/SearchResultsScreen.tsx": [
		68110,
		9
	],
	"./overrides/theme/wom/base/assets/Data/FiltersData": [
		84311,
		9
	],
	"./overrides/theme/wom/base/assets/Data/FiltersData.ts": [
		84311,
		9
	],
	"./overrides/theme/wom/base/assets/Data/ParentContainerData": [
		70260,
		9
	],
	"./overrides/theme/wom/base/assets/Data/ParentContainerData.ts": [
		70260,
		9
	],
	"./overrides/theme/wom/base/components/Commons/SelectBox/SelectBox": [
		41909,
		9
	],
	"./overrides/theme/wom/base/components/Commons/SelectBox/SelectBox.tsx": [
		41909,
		9
	],
	"./overrides/theme/wom/base/components/Contractor/Core/Order/CardOrder/CardOrdeItem": [
		74892,
		9
	],
	"./overrides/theme/wom/base/components/Contractor/Core/Order/CardOrder/CardOrdeItem.tsx": [
		74892,
		9
	],
	"./overrides/theme/wom/base/components/Contractor/Core/Order/OrderList": [
		25494,
		9
	],
	"./overrides/theme/wom/base/components/Contractor/Core/Order/OrderList.tsx": [
		25494,
		9
	],
	"./overrides/theme/wom/base/components/Core/DocumentsFiles/FileCard": [
		27634,
		9,
		7634
	],
	"./overrides/theme/wom/base/components/Core/DocumentsFiles/FileCard.tsx": [
		27634,
		9,
		7634
	],
	"./overrides/theme/wom/base/components/Core/DocumentsFiles/FilesList": [
		360,
		9,
		360
	],
	"./overrides/theme/wom/base/components/Core/DocumentsFiles/FilesList.tsx": [
		360,
		9,
		360
	],
	"./overrides/theme/wom/base/components/Core/Order/CardOrder/CardOrdeItem": [
		29316,
		9
	],
	"./overrides/theme/wom/base/components/Core/Order/CardOrder/CardOrdeItem.tsx": [
		29316,
		9
	],
	"./overrides/theme/wom/base/components/Core/Order/OrderList": [
		65973,
		9
	],
	"./overrides/theme/wom/base/components/Core/Order/OrderList.tsx": [
		65973,
		9
	],
	"./overrides/theme/wom/base/components/OrderDetail/Contractor/TagPrint/TagPrintContent/TagPrintContent": [
		85224,
		9,
		5224
	],
	"./overrides/theme/wom/base/components/OrderDetail/Contractor/TagPrint/TagPrintContent/TagPrintContent.tsx": [
		85224,
		9,
		5224
	],
	"./overrides/theme/wom/base/components/OrderDetail/TransitProductOrder/TransitAction": [
		26835,
		9
	],
	"./overrides/theme/wom/base/components/OrderDetail/TransitProductOrder/TransitAction.tsx": [
		26835,
		9
	],
	"./overrides/theme/wom/base/components/SearchForm/SearchForm": [
		41503,
		9
	],
	"./overrides/theme/wom/base/components/SearchForm/SearchForm.tsx": [
		41503,
		9
	],
	"./overrides/theme/wom/base/components/Theme/Header/Header": [
		1212,
		9
	],
	"./overrides/theme/wom/base/components/Theme/Header/Header.tsx": [
		1212,
		9
	],
	"./overrides/theme/wom/base/components/User/Login/LoginForm": [
		20722,
		9,
		722
	],
	"./overrides/theme/wom/base/components/User/Login/LoginForm.tsx": [
		20722,
		9,
		722
	],
	"./overrides/theme/wom/base/components/User/Login/Logo": [
		48297,
		9,
		8297
	],
	"./overrides/theme/wom/base/components/User/Login/Logo.tsx": [
		48297,
		9,
		8297
	],
	"./overrides/theme/wom/base/hooks/UseGetMenuUser": [
		81920,
		9
	],
	"./overrides/theme/wom/base/hooks/UseGetMenuUser.ts": [
		81920,
		9
	],
	"./overrides/theme/wom/base/hooks/UseGroupedOrderByCount": [
		79702,
		9
	],
	"./overrides/theme/wom/base/hooks/UseGroupedOrderByCount.ts": [
		79702,
		9
	],
	"./overrides/theme/wom/base/routes/List/RouteList": [
		46097,
		9
	],
	"./overrides/theme/wom/base/routes/List/RouteList.tsx": [
		46097,
		9
	],
	"./pages/DetailOrderScreens/Canceled/CanceledScreen": [
		80491,
		9
	],
	"./pages/DetailOrderScreens/Canceled/CanceledScreen.tsx": [
		80491,
		9
	],
	"./pages/DetailOrderScreens/Closed/ClosedScreen": [
		10709,
		9
	],
	"./pages/DetailOrderScreens/Closed/ClosedScreen.tsx": [
		10709,
		9
	],
	"./pages/DetailOrderScreens/Closed/UseClosedOrder": [
		4463,
		9
	],
	"./pages/DetailOrderScreens/Closed/UseClosedOrder.ts": [
		4463,
		9
	],
	"./pages/DetailOrderScreens/Confirm/ConfirmOrderScreen": [
		37182,
		9
	],
	"./pages/DetailOrderScreens/Confirm/ConfirmOrderScreen.tsx": [
		37182,
		9
	],
	"./pages/DetailOrderScreens/Confirm/PickingReducer": [
		80031,
		9
	],
	"./pages/DetailOrderScreens/Confirm/PickingReducer.ts": [
		80031,
		9
	],
	"./pages/DetailOrderScreens/Confirm/UseConfirmOrder": [
		53088,
		9
	],
	"./pages/DetailOrderScreens/Confirm/UseConfirmOrder.ts": [
		53088,
		9
	],
	"./pages/DetailOrderScreens/Custom/OrderDetailScreen": [
		16795,
		9,
		6795
	],
	"./pages/DetailOrderScreens/Custom/OrderDetailScreen.tsx": [
		16795,
		9,
		6795
	],
	"./pages/DetailOrderScreens/Delivered/DeliveredSreen": [
		87836,
		9
	],
	"./pages/DetailOrderScreens/Delivered/DeliveredSreen.tsx": [
		87836,
		9
	],
	"./pages/DetailOrderScreens/Delivered/UseDeliveredOrder": [
		7543,
		9
	],
	"./pages/DetailOrderScreens/Delivered/UseDeliveredOrder.ts": [
		7543,
		9
	],
	"./pages/DetailOrderScreens/Delivery/DeliveryScreen": [
		56121,
		9
	],
	"./pages/DetailOrderScreens/Delivery/DeliveryScreen.tsx": [
		56121,
		9
	],
	"./pages/DetailOrderScreens/Delivery/UseDeliveryOrder": [
		89348,
		9
	],
	"./pages/DetailOrderScreens/Delivery/UseDeliveryOrder.ts": [
		89348,
		9
	],
	"./pages/DetailOrderScreens/InReturn/InReturnScreen": [
		93938,
		9
	],
	"./pages/DetailOrderScreens/InReturn/InReturnScreen.tsx": [
		93938,
		9
	],
	"./pages/DetailOrderScreens/Package/PackageScreen": [
		50109,
		9
	],
	"./pages/DetailOrderScreens/Package/PackageScreen.tsx": [
		50109,
		9
	],
	"./pages/DetailOrderScreens/Package/UsePackageOrder": [
		29189,
		9
	],
	"./pages/DetailOrderScreens/Package/UsePackageOrder.tsx": [
		29189,
		9
	],
	"./pages/DetailOrderScreens/Pickup/PickupScreen": [
		45950,
		9
	],
	"./pages/DetailOrderScreens/Pickup/PickupScreen.tsx": [
		45950,
		9
	],
	"./pages/DetailOrderScreens/Pickup/UsePickupOrder": [
		65168,
		9
	],
	"./pages/DetailOrderScreens/Pickup/UsePickupOrder.ts": [
		65168,
		9
	],
	"./pages/DetailOrderScreens/Returned/ReturnedScreen": [
		86840,
		9
	],
	"./pages/DetailOrderScreens/Returned/ReturnedScreen.tsx": [
		86840,
		9
	],
	"./pages/DetailOrderScreens/Transit/TransitScreen": [
		68510,
		9
	],
	"./pages/DetailOrderScreens/Transit/TransitScreen.tsx": [
		68510,
		9
	],
	"./pages/DetailOrderScreens/Transit/UseTransitOrder": [
		55477,
		9
	],
	"./pages/DetailOrderScreens/Transit/UseTransitOrder.ts": [
		55477,
		9
	],
	"./pages/HomeScreens/HomeScreen/DashBoardScreen": [
		18018,
		9
	],
	"./pages/HomeScreens/HomeScreen/DashBoardScreen.tsx": [
		18018,
		9
	],
	"./pages/ManifestScreens/ManifestScreen": [
		49404,
		9
	],
	"./pages/ManifestScreens/ManifestScreen.tsx": [
		49404,
		9
	],
	"./pages/OrderScreens/OrderScreen": [
		51286,
		9
	],
	"./pages/OrderScreens/OrderScreen.tsx": [
		51286,
		9
	],
	"./pages/Report/ReportPage": [
		238,
		9
	],
	"./pages/Report/ReportPage.tsx": [
		238,
		9
	],
	"./pages/SearchResults/SearchResultsScreen": [
		42330,
		9
	],
	"./pages/SearchResults/SearchResultsScreen.tsx": [
		42330,
		9
	],
	"./pages/TransferScreens/TransferScreen": [
		58298,
		9
	],
	"./pages/TransferScreens/TransferScreen.tsx": [
		58298,
		9
	],
	"./pages/UserScreens/LoginScreen/LoginScreen": [
		28493,
		9
	],
	"./pages/UserScreens/LoginScreen/LoginScreen.tsx": [
		28493,
		9
	],
	"./pages/UserScreens/NewPassword/NewPasswordScreen": [
		12400,
		9
	],
	"./pages/UserScreens/NewPassword/NewPasswordScreen.tsx": [
		12400,
		9
	],
	"./pages/UserScreens/ProfileScreen/ProfileScreen": [
		60555,
		9
	],
	"./pages/UserScreens/ProfileScreen/ProfileScreen.tsx": [
		60555,
		9
	],
	"./pages/UserScreens/Remember/RememberScreen": [
		39487,
		9
	],
	"./pages/UserScreens/Remember/RememberScreen.tsx": [
		39487,
		9
	],
	"./react-app-env.d": [
		44398,
		7,
		4398
	],
	"./react-app-env.d.ts": [
		44398,
		7,
		4398
	],
	"./routes/AppRouter": [
		90579,
		9
	],
	"./routes/AppRouter.tsx": [
		90579,
		9
	],
	"./routes/DashboardRouter": [
		66103,
		9
	],
	"./routes/DashboardRouter.tsx": [
		66103,
		9
	],
	"./serviceWorkerRegistration": [
		82305,
		9
	],
	"./serviceWorkerRegistration.ts": [
		82305,
		9
	],
	"./services/AuthServices": [
		29216,
		9
	],
	"./services/AuthServices.ts": [
		29216,
		9
	],
	"./services/ItemsService": [
		94997,
		9
	],
	"./services/ItemsService.ts": [
		94997,
		9
	],
	"./services/ListenerServices": [
		6743,
		9
	],
	"./services/ListenerServices.ts": [
		6743,
		9
	],
	"./services/OSM": [
		71671,
		9
	],
	"./services/OSM.ts": [
		71671,
		9
	],
	"./services/OSRM": [
		45999,
		9
	],
	"./services/OSRM.ts": [
		45999,
		9
	],
	"./services/OrderServices": [
		75724,
		9
	],
	"./services/OrderServices.ts": [
		75724,
		9
	],
	"./services/OsrmServices": [
		63966,
		9,
		3966
	],
	"./services/OsrmServices.ts": [
		63966,
		9,
		3966
	],
	"./services/PasswordServices": [
		69426,
		9,
		9426
	],
	"./services/PasswordServices.ts": [
		69426,
		9,
		9426
	],
	"./services/ShippingGroupService": [
		46727,
		9
	],
	"./services/ShippingGroupService.ts": [
		46727,
		9
	],
	"./services/SourceService": [
		59556,
		9
	],
	"./services/SourceService.ts": [
		59556,
		9
	],
	"./setupTests": [
		22887,
		7,
		2887
	],
	"./setupTests.ts": [
		22887,
		7,
		2887
	],
	"./styled-jsx.d": [
		79168,
		9,
		9168
	],
	"./styled-jsx.d.ts": [
		79168,
		9,
		9168
	],
	"./theme/ThemeUI": [
		13708,
		9
	],
	"./theme/ThemeUI.ts": [
		13708,
		9
	],
	"./theme/assets/Data/FiltersData": [
		95678,
		9
	],
	"./theme/assets/Data/FiltersData.ts": [
		95678,
		9
	],
	"./theme/assets/Data/NoExistDeliveredData": [
		51477,
		9,
		1477
	],
	"./theme/assets/Data/NoExistDeliveredData.ts": [
		51477,
		9,
		1477
	],
	"./theme/assets/Data/RouteList": [
		76648,
		9
	],
	"./theme/assets/Data/RouteList.ts": [
		76648,
		9
	],
	"./theme/assets/Data/SendCodeOptions": [
		62105,
		9
	],
	"./theme/assets/Data/SendCodeOptions.ts": [
		62105,
		9
	],
	"./theme/assets/Data/ShippingTypeOptionsData": [
		21381,
		9
	],
	"./theme/assets/Data/ShippingTypeOptionsData.ts": [
		21381,
		9
	],
	"./theme/assets/Data/SideBarData": [
		43982,
		9
	],
	"./theme/assets/Data/SideBarData.tsx": [
		43982,
		9
	],
	"./theme/assets/Data/SummaryOptionsData": [
		84717,
		9
	],
	"./theme/assets/Data/SummaryOptionsData.tsx": [
		84717,
		9
	],
	"./theme/assets/Data/pageData": [
		23449,
		9
	],
	"./theme/assets/Data/pageData.tsx": [
		23449,
		9
	],
	"./theme/assets/img/LogosClients/wom-white.png": [
		57355,
		1,
		7355
	],
	"./theme/assets/img/LogosClients/wom.svg": [
		26882,
		1
	],
	"./theme/assets/img/bg_login.png": [
		42191,
		1,
		2191
	],
	"./theme/assets/img/ico_header_logo.svg": [
		21604,
		1,
		1604
	],
	"./theme/assets/img/javascript.png": [
		26787,
		1,
		6787
	],
	"./theme/assets/img/login_logo_omnix_white.svg": [
		53780,
		1,
		3780
	],
	"./theme/assets/img/omnix-logo.svg": [
		77200,
		1,
		7200
	],
	"./theme/assets/img/omnix.png": [
		26542,
		1,
		6542
	],
	"./theme/assets/img/tech.jpg": [
		57031,
		1,
		7031
	],
	"./theme/base/Animations": [
		6317,
		9
	],
	"./theme/base/Animations.ts": [
		6317,
		9
	],
	"./theme/base/Custom.styled": [
		21162,
		9
	],
	"./theme/base/Custom.styled.ts": [
		21162,
		9
	],
	"./theme/base/GlobalStyled": [
		26526,
		9
	],
	"./theme/base/GlobalStyled.ts": [
		26526,
		9
	],
	"./theme/base/Mixins": [
		24564,
		9
	],
	"./theme/base/Mixins.ts": [
		24564,
		9
	],
	"./theme/base/Variables": [
		9768,
		9
	],
	"./theme/base/Variables.ts": [
		9768,
		9
	],
	"./theme/common/Alert.styled": [
		75370,
		9
	],
	"./theme/common/Alert.styled.ts": [
		75370,
		9
	],
	"./theme/common/Button.styled": [
		87647,
		9
	],
	"./theme/common/Button.styled.ts": [
		87647,
		9
	],
	"./theme/common/CardItem.styled": [
		34793,
		9
	],
	"./theme/common/CardItem.styled.ts": [
		34793,
		9
	],
	"./theme/common/CardsDetails.styled": [
		15633,
		9
	],
	"./theme/common/CardsDetails.styled.ts": [
		15633,
		9
	],
	"./theme/common/CheckBox": [
		45412,
		9
	],
	"./theme/common/CheckBox.ts": [
		45412,
		9
	],
	"./theme/common/Collapsible": [
		79927,
		9,
		9927
	],
	"./theme/common/Collapsible.ts": [
		79927,
		9,
		9927
	],
	"./theme/common/ContentDetailOrderActions.styled": [
		27922,
		9
	],
	"./theme/common/ContentDetailOrderActions.styled.ts": [
		27922,
		9
	],
	"./theme/common/Grid.styled": [
		27983,
		9
	],
	"./theme/common/Grid.styled.ts": [
		27983,
		9
	],
	"./theme/common/Icon.styled": [
		8840,
		9
	],
	"./theme/common/Icon.styled.ts": [
		8840,
		9
	],
	"./theme/common/Input.styled": [
		40404,
		9
	],
	"./theme/common/Input.styled.ts": [
		40404,
		9
	],
	"./theme/common/Link.styled": [
		89118,
		9
	],
	"./theme/common/Link.styled.ts": [
		89118,
		9
	],
	"./theme/common/Manifest.styled": [
		52956,
		9
	],
	"./theme/common/Manifest.styled.ts": [
		52956,
		9
	],
	"./theme/common/Notification.styled": [
		75614,
		9
	],
	"./theme/common/Notification.styled.ts": [
		75614,
		9
	],
	"./theme/common/Paragraph.styled": [
		52056,
		9
	],
	"./theme/common/Paragraph.styled.ts": [
		52056,
		9
	],
	"./theme/common/RadioButton": [
		78702,
		9
	],
	"./theme/common/RadioButton.ts": [
		78702,
		9
	],
	"./theme/common/TimeLine": [
		15543,
		9,
		5543
	],
	"./theme/common/TimeLine.ts": [
		15543,
		9,
		5543
	],
	"./theme/common/Transfer.styled": [
		63808,
		9
	],
	"./theme/common/Transfer.styled.ts": [
		63808,
		9
	],
	"./theme/styled.d": [
		15489,
		9,
		5489
	],
	"./theme/styled.d.ts": [
		15489,
		9,
		5489
	],
	"./translates/config": [
		95110,
		9
	],
	"./translates/config.ts": [
		95110,
		9
	],
	"./translates/default/translation": [
		48888,
		3
	],
	"./translates/default/translation.json": [
		48888,
		3
	],
	"./translates/entel/translation": [
		45983,
		3
	],
	"./translates/entel/translation.json": [
		45983,
		3
	],
	"./translates/privilege/translation": [
		94701,
		3
	],
	"./translates/privilege/translation.json": [
		94701,
		3
	],
	"./translates/wom/translation": [
		37925,
		3
	],
	"./translates/wom/translation.json": [
		37925,
		3
	],
	"./types/CommonsTypes": [
		25478,
		9,
		5478
	],
	"./types/CommonsTypes.ts": [
		25478,
		9,
		5478
	],
	"./types/ContextPropType": [
		2590,
		9,
		2590
	],
	"./types/ContextPropType.ts": [
		2590,
		9,
		2590
	],
	"./types/DocumentsOrderType": [
		52677,
		9,
		2677
	],
	"./types/DocumentsOrderType.ts": [
		52677,
		9,
		2677
	],
	"./types/FilesFormType": [
		92132,
		9,
		2132
	],
	"./types/FilesFormType.ts": [
		92132,
		9,
		2132
	],
	"./types/InputPropsType": [
		14176,
		9,
		4176
	],
	"./types/InputPropsType.ts": [
		14176,
		9,
		4176
	],
	"./types/MultiClientType": [
		2654,
		9,
		2654
	],
	"./types/MultiClientType.ts": [
		2654,
		9,
		2654
	],
	"./types/OrderType": [
		49135,
		9,
		9135
	],
	"./types/OrderType.ts": [
		49135,
		9,
		9135
	],
	"./types/SourceType": [
		20557,
		9,
		557
	],
	"./types/SourceType.ts": [
		20557,
		9,
		557
	],
	"./types/VariantAlertType": [
		31293,
		9,
		1293
	],
	"./types/VariantAlertType.ts": [
		31293,
		9,
		1293
	],
	"./types/VariantButtonType": [
		5847,
		9,
		5847
	],
	"./types/VariantButtonType.ts": [
		5847,
		9,
		5847
	],
	"./types/VariantSpinnerType": [
		38975,
		9,
		8975
	],
	"./types/VariantSpinnerType.ts": [
		38975,
		9,
		8975
	],
	"./webapp-clients/Clients": [
		39888,
		9
	],
	"./webapp-clients/Clients.ts": [
		39888,
		9
	],
	"./webapp-clients/ENTEL": [
		63241,
		9
	],
	"./webapp-clients/ENTEL/": [
		63241,
		9
	],
	"./webapp-clients/ENTEL/index": [
		63241,
		9
	],
	"./webapp-clients/ENTEL/index.tsx": [
		63241,
		9
	],
	"./webapp-clients/PRVL": [
		60984,
		9
	],
	"./webapp-clients/PRVL/": [
		60984,
		9
	],
	"./webapp-clients/PRVL/Components/CustomFilters": [
		742,
		9,
		742
	],
	"./webapp-clients/PRVL/Components/CustomFilters.tsx": [
		742,
		9,
		742
	],
	"./webapp-clients/PRVL/Components/TagConsolidation": [
		72708,
		9,
		2708
	],
	"./webapp-clients/PRVL/Components/TagConsolidation.tsx": [
		72708,
		9,
		2708
	],
	"./webapp-clients/PRVL/Components/TagCustomOrder": [
		34322,
		9,
		4322
	],
	"./webapp-clients/PRVL/Components/TagCustomOrder.tsx": [
		34322,
		9,
		4322
	],
	"./webapp-clients/PRVL/Components/TicketOrder": [
		78728,
		9,
		8728
	],
	"./webapp-clients/PRVL/Components/TicketOrder.tsx": [
		78728,
		9,
		8728
	],
	"./webapp-clients/PRVL/index": [
		60984,
		9
	],
	"./webapp-clients/PRVL/index.tsx": [
		60984,
		9
	],
	"./webapp-clients/SDM": [
		14898,
		9
	],
	"./webapp-clients/SDM/": [
		14898,
		9
	],
	"./webapp-clients/SDM/index": [
		14898,
		9
	],
	"./webapp-clients/SDM/index.tsx": [
		14898,
		9
	],
	"./webapp-clients/Sbx": [
		23536,
		9
	],
	"./webapp-clients/Sbx/": [
		23536,
		9
	],
	"./webapp-clients/Sbx/components/TagCustomOrder": [
		98347,
		9,
		8347
	],
	"./webapp-clients/Sbx/components/TagCustomOrder.tsx": [
		98347,
		9,
		8347
	],
	"./webapp-clients/Sbx/index": [
		23536,
		9
	],
	"./webapp-clients/Sbx/index.tsx": [
		23536,
		9
	],
	"./webapp-clients/Wom": [
		5559,
		9
	],
	"./webapp-clients/Wom/": [
		5559,
		9
	],
	"./webapp-clients/Wom/Components/GenerateDocumentButton/GenerateDocumentButton": [
		54169,
		9,
		4169
	],
	"./webapp-clients/Wom/Components/GenerateDocumentButton/GenerateDocumentButton.tsx": [
		54169,
		9,
		4169
	],
	"./webapp-clients/Wom/Components/GenerateDocumentButton/useGenerateDocument": [
		94352,
		9,
		4352
	],
	"./webapp-clients/Wom/Components/GenerateDocumentButton/useGenerateDocument.ts": [
		94352,
		9,
		4352
	],
	"./webapp-clients/Wom/Components/NoExistTransit": [
		17240,
		9,
		7240
	],
	"./webapp-clients/Wom/Components/NoExistTransit/": [
		17240,
		9,
		7240
	],
	"./webapp-clients/Wom/Components/NoExistTransit/NoExistDelivered.styled": [
		42714,
		9,
		2714
	],
	"./webapp-clients/Wom/Components/NoExistTransit/NoExistDelivered.styled.ts": [
		42714,
		9,
		2714
	],
	"./webapp-clients/Wom/Components/NoExistTransit/NoExistTransit": [
		73963,
		9,
		3963
	],
	"./webapp-clients/Wom/Components/NoExistTransit/NoExistTransit.tsx": [
		73963,
		9,
		3963
	],
	"./webapp-clients/Wom/Components/NoExistTransit/index": [
		17240,
		9,
		7240
	],
	"./webapp-clients/Wom/Components/NoExistTransit/index.ts": [
		17240,
		9,
		7240
	],
	"./webapp-clients/Wom/Components/NoExistTransit/useFailedTransit": [
		37161,
		9,
		7161
	],
	"./webapp-clients/Wom/Components/NoExistTransit/useFailedTransit.ts": [
		37161,
		9,
		7161
	],
	"./webapp-clients/Wom/Components/TagCustomOrder": [
		72698,
		9,
		2698
	],
	"./webapp-clients/Wom/Components/TagCustomOrder.tsx": [
		72698,
		9,
		2698
	],
	"./webapp-clients/Wom/Components/ViewContentMedia/ContentFileMedia": [
		79698,
		9,
		9397,
		9698
	],
	"./webapp-clients/Wom/Components/ViewContentMedia/ContentFileMedia.styled": [
		44002,
		9,
		4002
	],
	"./webapp-clients/Wom/Components/ViewContentMedia/ContentFileMedia.styled.ts": [
		44002,
		9,
		4002
	],
	"./webapp-clients/Wom/Components/ViewContentMedia/ContentFileMedia.tsx": [
		79698,
		9,
		9397,
		9698
	],
	"./webapp-clients/Wom/Components/ViewContentMedia/useDeleteMediaFile": [
		73831,
		9,
		3831
	],
	"./webapp-clients/Wom/Components/ViewContentMedia/useDeleteMediaFile.ts": [
		73831,
		9,
		3831
	],
	"./webapp-clients/Wom/index": [
		5559,
		9
	],
	"./webapp-clients/Wom/index.tsx": [
		5559,
		9
	],
	"./webapp-clients/shiperto": [
		92489,
		9
	],
	"./webapp-clients/shiperto/": [
		92489,
		9
	],
	"./webapp-clients/shiperto/index": [
		92489,
		9
	],
	"./webapp-clients/shiperto/index.tsx": [
		92489,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 85323;
module.exports = webpackAsyncContext;